// HT Calculator JavaScript - COMPLETE VERSION (WITHOUT PRICING BREAKDOWN)
class HTCalculator {
  constructor() {
    this.form = document.getElementById('ht-calculator-form');
    this.materialSelect = document.getElementById('ht-material-select');
    this.shapeSelect = document.getElementById('ht-shape-select');
    this.sizeSelect = document.getElementById('ht-size-select');
    this.quantitySelect = document.getElementById('ht-quantity-select');
    this.printSidesSelect = document.getElementById('ht-print-sides-select');
    this.printInkSelect = document.getElementById('ht-print-ink-select');
    this.cornerStyleSelect = document.getElementById('ht-corner-style-select');
    this.eyeletSelect = document.getElementById('ht-eyelet-select');
    
    // Drill hole elements
    this.drillDiameterSelect = document.getElementById('ht-drill-diameter-select');
    this.drillPositionSelect = document.getElementById('ht-drill-position-select');
    
    this.customSizeFields = document.getElementById('ht-custom-size-fields');
    this.customWidthInput = document.getElementById('ht-custom-width');
    this.customHeightInput = document.getElementById('ht-custom-height');
    this.customQuantityField = document.getElementById('ht-custom-quantity-field');
    this.customQuantityInput = document.getElementById('ht-custom-quantity');

    // Size validation elements
    this.widthConstraint = document.getElementById('ht-width-constraint');
    this.heightConstraint = document.getElementById('ht-height-constraint');
    this.sizeValidation = document.getElementById('ht-size-validation');

    // String Elements
    this.stringAttachmentSelect = document.getElementById('ht-string-attachment-select');
    this.stringTypeSelect = document.getElementById('ht-string-type-select');
    this.stringTypeFieldContainer = document.getElementById('ht-string-type-field');

    // NEW PRICING FEATURE ELEMENTS
    this.multipleDesignsInput = document.getElementById('ht-multiple-designs');
    this.variableDataSelect = document.getElementById('ht-variable-data-select');
    this.variableDataMessage = document.getElementById('ht-variable-data-message');
    this.sequentialNumbersSelect = document.getElementById('ht-sequential-numbers-select');
    this.sequentialNumbersInput = document.getElementById('ht-sequential-numbers-input');
    this.sequentialRangeInput = document.getElementById('ht-sequential-range');
    this.perforationCheckbox = document.getElementById('ht-perforation');
    this.designMyArtworkCheckbox = document.getElementById('ht-design-my-artwork');

    // Label elements for dynamic text changes
    this.printSidesLabel = document.querySelector('label[for="ht-print-sides-select"]');
    this.printInkLabel = document.querySelector('label[for="ht-print-ink-select"]');
    
    // Field containers
    this.sizeFieldContainer = this.sizeSelect.closest('.ht-calculator-field');
    this.cornerStyleFieldContainer = document.getElementById('ht-corner-style-field');
    this.eyeletFieldContainer = this.eyeletSelect.closest('.ht-calculator-field');
    this.drillDiameterFieldContainer = document.getElementById('ht-drill-diameter-field');
    this.drillPositionFieldContainer = document.getElementById('ht-drill-position-field');
    
    // 🔥 SIMPLIFIED: Basic price display only (no detailed breakdown)
    this.totalPriceDisplay = document.getElementById('ht-calculator-total-price');
    this.pricePerTagDisplay = document.getElementById('ht-calculator-price-per-tag');
    
    // Load data
    this.sizesData = this.loadSizesData();
    this.pricingConstants = this.loadPricingConstants();
    this.drillDiametersData = this.loadDrillDiametersData();
    this.drillPositionsData = this.loadDrillPositionsData();
    this.foilColoursData = this.loadFoilColoursData();
    
    // Track original labels for restoration
    this.originalLabels = {
      printSides: this.printSidesLabel ? this.printSidesLabel.textContent : 'Printed Sides',
      printInk: this.printInkLabel ? this.printInkLabel.textContent : 'Printed Ink'
    };

    // Track custom size state
    this.isCustomSizeActive = false;
    this.customSizeReason = '';
    
    this.init();
  }
  
  init() {
  this.bindEvents();
  this.resetCalculator();
  this.hidePriceDisplay();
  
  // ✅ PHASE 1A: Emit calculator ready event for state manager
  document.dispatchEvent(new CustomEvent('calculator:ready', {
    detail: { calculatorType: 'regular' }
  }));
  
  // Keep existing functionality
  this.dispatchCalculatorEvent('ht-calculator-ready', { isReady: false });

  // Listen for cart success to reset calculator
  document.addEventListener('cart:item-added-success', () => {

    this.resetCalculator();
  });
}

  // 🚀 Event dispatching system for communication with external components
  dispatchCalculatorEvent(eventName, data) {
    const event = new CustomEvent(eventName, {
      detail: data,
      bubbles: true
    });
    
    window.dispatchEvent(event);

  }

// 🚀 PHASE 1: State manager event emissions
emitStateChange(fieldName) {
  document.dispatchEvent(new CustomEvent('calculator:state-change', {
    detail: { 
      field: fieldName,
      calculatorType: 'regular',
      timestamp: Date.now()
    }
  }));
}

// 🚀 PHASE 1B: Direct calculator methods
exportState() {
  const state = {
    calculatorType: 'regular',
    isValid: this.isValid(),
    timestamp: Date.now(),
    
    // Core selections
    material: this.materialSelect.value || '',
    shape: this.shapeSelect.value || '',
    size: this.sizeSelect.value || '',
    quantity: this.getCurrentQuantity(),
    print_sides: this.printSidesSelect.value || '',
    print_ink: this.printInkSelect.value || '',
    
    // Custom dimensions (if applicable)
    custom_size: this.isCustomSizeActive ? {
      width: parseFloat(this.customWidthInput.value) || 0,
      height: parseFloat(this.customHeightInput.value) || 0,
      unit: 'mm',
      reason: this.customSizeReason
    } : null,
    
    // Enhancement options
    corner_style: this.cornerStyleSelect?.value || '',
    drill_diameter: this.drillDiameterSelect?.value || '',
    drill_position: this.drillPositionSelect?.value || '',
    eyelet: this.eyeletSelect?.value || '',
    string_attachment: this.stringAttachmentSelect?.value || '',
    string_type: this.stringTypeSelect?.value || '',
    
    // NEW pricing features
    multiple_designs: this.multipleDesignsInput?.value || 1,
    variable_data: this.variableDataSelect?.value === 'yes',
    sequential_data: this.sequentialNumbersSelect?.value === 'yes',
    perforation: this.perforationCheckbox?.checked || false,
    design_my_artwork: this.designMyArtworkCheckbox?.checked || false,
    
    // Pricing data (if available)
    pricing: this.getCurrentPricing()
  };
  
  return state;
}

isValid() {
  const materialOption = this.materialSelect.selectedOptions[0];
  const shapeValue = this.shapeSelect.value;
  const sizeOption = this.sizeSelect.selectedOptions[0];
  const quantity = this.getCurrentQuantity();
  
  const hasMaterial = materialOption && materialOption.value;
  const hasShape = shapeValue;
  const hasQuantity = quantity > 0;
  const hasPrintSides = this.printSidesSelect.value && this.printSidesSelect.value !== '';
  const hasPrintInk = this.printInkSelect.value && this.printInkSelect.value !== '';
  
  // Check size requirements
  let hasSize = false;
  if (shapeValue === 'custom' || this.sizeSelect.value === 'custom_size') {
    hasSize = this.hasValidCustomSize();
  } else {
    hasSize = sizeOption && sizeOption.value;
  }
  
  const isComplete = hasMaterial && hasShape && hasSize && hasQuantity && hasPrintSides && hasPrintInk;
  
  return {
    isComplete,
    isValid: isComplete,
    missing: {
      material: !hasMaterial,
      shape: !hasShape,
      size: !hasSize,
      quantity: !hasQuantity,
      print_sides: !hasPrintSides,
      print_ink: !hasPrintInk
    }
  };
}

getCurrentPricing() {
  if (!this.isValid().isComplete) {
    return null;
  }
  
  // Extract pricing from display elements or last calculation
  const totalPrice = this.totalPriceDisplay?.textContent;
  const pricePerTag = this.pricePerTagDisplay?.textContent;
  
  return {
    total_display: totalPrice,
    per_tag_display: pricePerTag,
    currency: 'GBP',
    includes_vat: true
  };
}


  // ✅ Robust size data loading with fallback
  loadSizesData() {
    // Try primary data first
    try {
      var sizesScript = document.getElementById('ht-calculator-sizes-data');
      if (!sizesScript) {

        return this.loadFallbackSizesData();
      }
      
      var sizesData = JSON.parse(sizesScript.textContent);

      // Validate that we have some shapes with sizes
      var hasValidData = Object.keys(sizesData).some(function(shape) {
        return Array.isArray(sizesData[shape]) && sizesData[shape].length > 0;
      });
      
      if (!hasValidData) {

        return this.loadFallbackSizesData();
      }
      
      return sizesData;
      
    } catch (error) {
      console.error('❌ Error parsing primary sizes JSON, using fallback:', error);
      return this.loadFallbackSizesData();
    }
  }

  // NEW: Fallback data loader
  loadFallbackSizesData() {
    try {
      var fallbackScript = document.getElementById('ht-calculator-sizes-fallback');
      if (!fallbackScript) {
        console.error('❌ Fallback sizes script also missing - critical error');
        return this.getHardcodedSizesFallback();
      }
      
      var fallbackData = JSON.parse(fallbackScript.textContent);

      return fallbackData;
      
    } catch (error) {
      console.error('❌ Even fallback sizes failed to parse:', error);
      return this.getHardcodedSizesFallback();
    }
  }

  // Last resort hardcoded data
  getHardcodedSizesFallback() {

    return {
      rectangle: [{"display_name": "50mm × 100mm", "width": 50, "height": 100, "handle": "rectangle_50x100mm", "tags_per_sheet": 20, "flat_width": 50, "flat_height": 100}],
      square: [{"display_name": "50mm × 50mm", "width": 50, "height": 50, "handle": "square_50x50mm", "tags_per_sheet": 40, "flat_width": 50, "flat_height": 50}],
      round: [{"display_name": "50mm", "width": 50, "height": 50, "handle": "round_50mm", "tags_per_sheet": 30, "flat_width": 50, "flat_height": 50}],
      oval: [{"display_name": "40mm × 60mm", "width": 40, "height": 60, "handle": "oval_40x60mm", "tags_per_sheet": 36, "flat_width": 40, "flat_height": 60}]
    };
  }
  
  //  ✅ Updated pricing constants with consistent defaults (0% markup) + NEW PRICING FEATURES
  loadPricingConstants() {
    try {
      var constantsScript = document.getElementById('ht-calculator-pricing-constants');
      var constants = constantsScript ? JSON.parse(constantsScript.textContent) : {};
      
      //  ✅  Ensure consistent defaults that match business rules (0% markup) + NEW FEATURES
      var Constants = {
        bleed_addition: constants.bleed_addition || 4,
        guillotine_setup_charge: constants.guillotine_setup_charge || 1000, //  £10 default
        guillotine_cutting_rate: constants.guillotine_cutting_rate || 45,
        digital_die_cut_setup_charge: constants.digital_die_cut_setup_charge || 1000, // £10 in pence
        digital_die_cut_per_cut_charge: constants.digital_die_cut_per_cut_charge || 2, // £0.02 in pence
        markup_percentage: constants.markup_percentage !== undefined ? constants.markup_percentage : 0, //  0% markup
        artwork_setup_charge: constants.artwork_setup_charge || 1000, // £10 in pence
        guillotine_cuts_per_hour: constants.guillotine_cuts_per_hour || 120,
        guillotine_cutting_weight: constants.guillotine_cutting_weight || 300,
        guillotine_cutting_pile: constants.guillotine_cutting_pile || 100,
        service_charge: constants.service_charge || 1000, // 
        delivery_charge: constants.delivery_charge || 695,  // 
        multiple_designs_charge: constants.multiple_designs_charge || 250, // £2.50 per extra design
        variable_data_setup: constants.variable_data_setup || 1000, // £10 one-time setup
        sequential_numbers_setup: constants.sequential_numbers_setup || 1000, // £10 one-time setup
        perforation_setup_charge: constants.perforation_setup_charge || 1000, // £10 setup
        perforation_per_1000_charge: constants.perforation_per_1000_charge || 1000, // £10 per 1000
        design_my_artwork: constants.design_my_artwork || 2500 // £25 one-time charge
      };
      
      return Constants;
    } catch (error) {
      console.error('Error loading pricing constants:', error);
      // ✅ Updated fallback defaults (0% markup) + NEW FEATURES
      return {
        bleed_addition: 4,
        guillotine_setup_charge: 1000, //  £10 in pence
        guillotine_cutting_rate: 45,
        digital_die_cut_setup_charge: 1000, // £10 in pence
        digital_die_cut_per_cut_charge: 2, // £0.02 in pence
        markup_percentage: 0, //  0% markup 
        artwork_setup_charge: 1000, // £10 in pence
        guillotine_cuts_per_hour: 120,
        guillotine_cutting_weight: 300,
        guillotine_cutting_pile: 100,
        service_charge: 1000, //  £10 in pence
        delivery_charge: 695,   //  £6.95 in pence
        multiple_designs_charge: 250, // £2.50 per extra design
        variable_data_setup: 1000, // £10 one-time setup
        sequential_numbers_setup: 1000, // £10 one-time setup
        perforation_setup_charge: 1000, // £10 setup
        perforation_per_1000_charge: 1000, // £10 per 1000
        design_my_artwork: 2500 // £25 one-time charge
      };
    }
  }
  
  loadDrillDiametersData() {
    try {
      var drillDiametersScript = document.getElementById('ht-calculator-drill-diameters-data');
      if (!drillDiametersScript) {
        return {};
      }
      return JSON.parse(drillDiametersScript.textContent);
    } catch (error) {
      console.error('❌ Error loading drill diameters data:', error);
      return {};
    }
  }
  
  loadDrillPositionsData() {
    try {
      var drillPositionsScript = document.getElementById('ht-calculator-drill-positions-data');
      if (!drillPositionsScript) {
        return {};
      }
      return JSON.parse(drillPositionsScript.textContent);
    } catch (error) {
      console.error('❌ Error loading drill positions data:', error);
      return {};
    }
  }

  //  Load foil colours metaobjects
  loadFoilColoursData() {
    try {
      var foilColoursScript = document.getElementById('ht-calculator-foil-colours-data');
      if (!foilColoursScript) {

        return {};
      }
      
      var foilColoursData = JSON.parse(foilColoursScript.textContent);
      
      return foilColoursData;
    } catch (error) {
      console.error('❌ Error loading foil colours data:', error);
      return {};
    }
  }

  // Check if current material supports foil
  isFoilMaterial() {
    var materialOption = this.materialSelect.selectedOptions[0];
    if (!materialOption || !materialOption.value) return false;

    return materialOption.dataset.supportsFoil === 'true' || materialOption.dataset.supportsFoil === true;
  }

  // Determine sheet dimensions based on cutting method
getSheetDimensions(shapeValue) {
  // Determine if using guillotine or digital die-cutting
  var isGuillotine = shapeValue === 'rectangle' || shapeValue === 'square';
  
  if (isGuillotine) {
    // Guillotine sheet dimensions
    return {
      width: 434,
      height: 304,
      method: 'guillotine'
    };
  } else {
    // Digital die-cut sheet dimensions
    return {
      width: 426,
      height: 296,
      method: 'digital'
    };
  }
}

  loadCornerStylesData() {
    try {
      var cornerStylesScript = document.getElementById('ht-calculator-corner-styles-data');
      if (!cornerStylesScript) {
        return {};
      }
      return JSON.parse(cornerStylesScript.textContent);
    } catch (error) {
      console.error('❌ Error loading corner styles data:', error);
      return {};
    }
  }
  
  bindEvents() {
    var self = this;
    
    // Material selection change
    this.materialSelect.addEventListener('change', function() {
      self.onMaterialChange();
    });
    
    // Shape selection change
    this.shapeSelect.addEventListener('change', function() {
      self.onShapeChange();
    });
    
    // Size selection change
    this.sizeSelect.addEventListener('change', function() {
      self.onSizeChange();
    });
    
    // Quantity selection change
    this.quantitySelect.addEventListener('change', function() {
      self.onQuantityChange();
    });
    
    // Print sides selection change
    this.printSidesSelect.addEventListener('change', function() {
      self.onPrintSidesChange();
    });
    
    // Print ink selection change
    this.printInkSelect.addEventListener('change', function() {
      self.onPrintInkChange();
    });
    
    // Corner style selection change
    if (this.cornerStyleSelect) {
      this.cornerStyleSelect.addEventListener('change', function() {
        self.onCornerStyleChange();
      });
    }
    
    // Drill diameter selection change
    if (this.drillDiameterSelect) {
      this.drillDiameterSelect.addEventListener('change', function() {
        self.onDrillDiameterChange();
      });
    }
    
    // Drill position selection change
    if (this.drillPositionSelect) {
      this.drillPositionSelect.addEventListener('change', function() {
        self.onDrillPositionChange();
      });
    }
    
    // Eyelet selection change
    if (this.eyeletSelect) {
      this.eyeletSelect.addEventListener('change', function() {
        self.onEyeletChange();
      });
    }

    // String selection change
    if(this.stringAttachmentSelect){
      this.stringAttachmentSelect.addEventListener('change', function() {
        self.onStringAttachmentChange();
      });
    }
    if(this.stringTypeSelect){
      this.stringTypeSelect.addEventListener('change', function() {
        self.onStringTypeChange();
      });
    }

    // ✨ NEW PRICING FEATURE EVENT LISTENERS
    if (this.multipleDesignsInput) {
      this.multipleDesignsInput.addEventListener('input', function() {
        self.onMultipleDesignsChange();
      });
    }

    if (this.variableDataSelect) {
      this.variableDataSelect.addEventListener('change', function() {
        self.onVariableDataChange();
      });
    }

    if (this.sequentialNumbersSelect) {
      this.sequentialNumbersSelect.addEventListener('change', function() {
        self.onSequentialNumbersChange();
      });
    }

    if (this.perforationCheckbox) {
      this.perforationCheckbox.addEventListener('change', function() {
        self.onPerforationChange();
      });
    }

    if (this.designMyArtworkCheckbox) {
      this.designMyArtworkCheckbox.addEventListener('change', function() {
        self.onDesignMyArtworkChange();
      });
    }

    // Custom quantity input
    this.customQuantityInput.addEventListener('input', function() {
      self.onCustomQuantityChange();
    });
    
    // Custom size inputs
    this.customWidthInput.addEventListener('input', function() {
      self.onCustomSizeChange();
    });
    
    this.customHeightInput.addEventListener('input', function() {
      self.onCustomSizeChange();
    });
  }
  
  // ========================================
  // UPDATED: SIMPLIFIED MATERIAL CHANGE HANDLER + NEW FEATURES ENABLE
  // ========================================
  onMaterialChange() {
    var selectedMaterial = this.materialSelect.value;
    var selectedOption = this.materialSelect.selectedOptions[0];
    

    // Update material selection state
    this.updateSelectionState(this.materialSelect);
    
    if (selectedMaterial && selectedMaterial !== '') {

      // Update labels based on material type
      var isFoil = this.isFoilMaterial();
      
      if (isFoil) {
        if (this.printSidesLabel) {
          this.printSidesLabel.textContent = 'Foiled Sides';
        }
        if (this.printInkLabel) {
          this.printInkLabel.textContent = 'Foiled Colour';
        }

      } else {
        if (this.printSidesLabel) {
          this.printSidesLabel.textContent = this.originalLabels.printSides;
        }
        if (this.printInkLabel) {
          this.printInkLabel.textContent = this.originalLabels.printInk;
        }

        this.emitStateChange('material');
      }

      // Update custom size constraints based on material
      this.updateCustomSizeConstraints();
      
      // ✅ Populate and enable print options (no cascade needed)
      this.populateAndEnablePrintSides(isFoil);
      this.populateAndEnablePrintInk(isFoil);
      
      // Enable new pricing features 
      this.enableNewPricingFeatures();
      
      // Enable shape selection
      this.shapeSelect.disabled = false;
      this.updateSelectionState(this.shapeSelect);

      // Reset dependent fields but don't reset print options (they're already set)
      this.shapeSelect.value = '';
      this.resetSizeSelection();
      this.resetQuantitySelection();
      this.resetCustomFields();
      this.resetOptionalFeatures(); // Reset optional features only
      
      // Clear tracking data so options get repopulated for new material
      if (this.cornerStyleSelect) {
        this.cornerStyleSelect.dataset.lastPopulatedFor = '';
      }
      if (this.drillDiameterSelect) {
        this.drillDiameterSelect.dataset.lastPopulatedFor = '';
      }
      
      // Update all selection states
      this.updateAllSelectionStates();
      
      this.calculatePriceIfReady();
    } else {

      this.resetCalculator();
    }
  }

  // Enable new pricing features when material is selected 
  enableNewPricingFeatures() {
    if (this.multipleDesignsInput) {
      this.multipleDesignsInput.disabled = false;
      this.updateSelectionState(this.multipleDesignsInput);
    }
    
    if (this.variableDataSelect) {
      this.variableDataSelect.disabled = false;
    }
    
    if (this.sequentialNumbersSelect) {
      this.sequentialNumbersSelect.disabled = false;
    }
    
    if (this.perforationCheckbox) {
      this.perforationCheckbox.disabled = false;
    }
    if (this.designMyArtworkCheckbox) {
      this.designMyArtworkCheckbox.disabled = false;
    }
    

  }

  // PRICING FEATURE HANDLERS
  onMultipleDesignsChange() {
    var designs = parseInt(this.multipleDesignsInput.value) || 1;
    if (designs < 1) {
      this.multipleDesignsInput.value = 1;
    }
    if (designs > 50) {
      this.multipleDesignsInput.value = 50;
    }
    

    this.calculatePriceIfReady();
  }

  onVariableDataChange() {
    var isEnabled = this.variableDataSelect.value === 'yes';
    
    if (isEnabled) {
      this.variableDataMessage.style.display = 'block';
    } else {
      this.variableDataMessage.style.display = 'none';
    }
    

    this.calculatePriceIfReady();
  }

  onSequentialNumbersChange() {
    var isEnabled = this.sequentialNumbersSelect.value === 'yes';
    
    if (isEnabled) {
      this.sequentialNumbersInput.style.display = 'block';
    } else {
      this.sequentialNumbersInput.style.display = 'none';
      this.sequentialRangeInput.value = '';
    }
    

    this.calculatePriceIfReady();
  }

  onPerforationChange() {

    this.calculatePriceIfReady();
  }

  onDesignMyArtworkChange() {

    this.calculatePriceIfReady();
  }

  // PRICING FEATURE CALCULATION METHODS
  calculateMultipleDesignsCost() {
    if (!this.multipleDesignsInput || this.multipleDesignsInput.disabled) {
      return { total: 0, calculation: '', name: '' };
    }
    
    var designs = parseInt(this.multipleDesignsInput.value) || 1;
    var extraDesigns = Math.max(0, designs - 1); // First design included
    var costPerExtraDesign = (this.pricingConstants.multiple_designs_charge || 250) / 100;
    var totalCost = extraDesigns * costPerExtraDesign;
    
    var calculation = '';
    if (extraDesigns > 0) {
      calculation = extraDesigns + ' extra designs × £' + costPerExtraDesign.toFixed(2);
    } else {
      calculation = 'First design included';
    }
    
    return {
  total: this.roundToPence(totalCost),
  calculation: calculation,
  name: designs + ' Design' + (designs > 1 ? 's' : '')
};
  }

  calculateVariableDataCost() {
    if (!this.variableDataSelect || this.variableDataSelect.value !== 'yes' || this.variableDataSelect.disabled) {
      return { total: 0, calculation: '', name: '' };
    }
    
    var setupCost = (this.pricingConstants.variable_data_setup || 1000) / 100;
    
    return {
  total: this.roundToPence(setupCost),
  calculation: 'One-time setup charge',
  name: 'Variable Data Printing'
};
  }

  calculateSequentialNumbersCost() {
    if (!this.sequentialNumbersSelect || this.sequentialNumbersSelect.value !== 'yes' || this.sequentialNumbersSelect.disabled) {
      return { total: 0, calculation: '', name: '' };
    }
    
    var setupCost = (this.pricingConstants.sequential_numbers_setup || 1000) / 100;
    
    return {
  total: this.roundToPence(setupCost),
  calculation: 'One-time setup charge',
  name: 'Sequential Numbers'
};
  }

  calculatePerforationCost(quantity) {
    if (!this.perforationCheckbox || !this.perforationCheckbox.checked || this.perforationCheckbox.disabled) {
      return { total: 0, calculation: '', name: '' };
    }
    
    var setupCost = (this.pricingConstants.perforation_setup_charge || 1000) / 100;
    var perThousandCost = (this.pricingConstants.perforation_per_1000_charge || 1000) / 100;
    var quantityCost = (quantity / 1000) * perThousandCost;
    var totalCost = setupCost + quantityCost;
    
    var calculation = '£' + setupCost.toFixed(2) + ' setup + ' + quantity + ' × £' + perThousandCost.toFixed(2) + '/1000';
    
    return {
  total: this.roundToPence(totalCost),
  calculation: calculation,
  name: 'Perforation'
};
  }

  calculateDesignMyArtworkCost() {
    if (!this.designMyArtworkCheckbox || !this.designMyArtworkCheckbox.checked || this.designMyArtworkCheckbox.disabled) {
      return { total: 0, calculation: '', name: '' };
    }
    
    var designCost = (this.pricingConstants.design_my_artwork || 2500) / 100;
    
    return {
  total: this.roundToPence(designCost),
  calculation: 'Professional design service',
  name: 'Design My Artwork'
};
  }

  // ========================================
  // SHAPE CHANGE HANDLER
  // ========================================
  onShapeChange() {
    var selectedShape = this.shapeSelect.value;
    var shapeOption = this.shapeSelect.selectedOptions[0];
    

    
    // Update shape selection state
    this.updateSelectionState(this.shapeSelect);
    
    if (selectedShape) {
      // Enable size selection
      this.sizeSelect.disabled = false;
      this.updateSelectionState(this.sizeSelect);

      // Populate sizes for this shape
      this.populateSizes(selectedShape);
      
      // Update custom size constraints based on new shape (affects cutting method)
      this.updateCustomSizeConstraints();
      
      // Enable optional features based on shape compatibility
      this.enableOptionalFeaturesForShape(shapeOption);


    // 🔲 CORNERING VISIBILITY LOGIC
    
    // Determine if this is a custom die-cut shape vs standard shape
    const isCustomDieCutShape = selectedShape === 'custom';
    const isRectangle = selectedShape === 'rectangle';
    const isSquare = selectedShape === 'square';
    const isRound = selectedShape === 'round';
    const isOval = selectedShape === 'oval';
    
    // Check material type
    const materialOption = this.materialSelect.selectedOptions[0];
    const isFoil = materialOption && materialOption.dataset.supportsFoil === 'true';
    
    // Get allowed corner styles from shape metaobject
    const allowedCornerStyles = shapeOption ? shapeOption.dataset.allowedCornerStyles : '';
    
    
    //  Block cornering for custom die-cut shapes
    if (isCustomDieCutShape) {
      this.hideCornerStyleField();

    }
    // Block cornering for round/oval (no corners to style)
    else if (isRound || isOval) {
      this.hideCornerStyleField();

    }
    // Enable cornering for Rectangle/Square with allowed corner styles
    else if ((isRectangle || isSquare) && allowedCornerStyles && allowedCornerStyles.trim() !== '') {
      if (this.cornerStyleFieldContainer) {
        this.cornerStyleFieldContainer.style.display = 'block';
      }
      if (this.cornerStyleSelect) {
        this.cornerStyleSelect.disabled = false;
        
        // Only repopulate if needed (avoid unnecessary redraws)
        if (this.cornerStyleSelect.options.length <= 1 || 
            this.cornerStyleSelect.dataset.lastPopulatedFor !== selectedShape) {
          this.populateCornerStyles(allowedCornerStyles);
          this.cornerStyleSelect.dataset.lastPopulatedFor = selectedShape;
        }
      }
      

    }
    // Default: hide cornering
    else {
      this.hideCornerStyleField();

    }
      
      // Handle custom shape (maintains existing functionality)
      if (selectedShape === 'custom') {
        this.showCustomSizeFields('custom_shape');

      } else {
        // Only hide if not showing custom size for other reason
        if (this.customSizeReason === 'custom_shape') {
          this.hideCustomSizeFields();

        }
        this.emitStateChange('shape');
      }
      
      // Reset dependent selections but don't reset print options or optional features
      this.sizeSelect.value = '';
      this.resetQuantitySelection();
      
      // Re-validate custom size after shape change
      if (this.isCustomSizeActive) {
        var isValid = this.validateCustomSize();
      }
      
      this.calculatePriceIfReady();
    } else {

      this.resetSizeSelection();
      this.resetQuantitySelection();
      this.hideCustomSizeFields();
      this.resetOptionalFeatures();
      this.hideCornerStyleField();
    }
  }

  // ========================================
  // SIMPLIFIED SIZE CHANGE HANDLER
  // ========================================
  onSizeChange() {
    var selectedSize = this.sizeSelect.value;
    
    
    // Update size selection state
    this.updateSelectionState(this.sizeSelect);
    
    if (selectedSize === 'custom_size') {
      // Custom size option selected - show custom fields
      this.showCustomSizeFields('custom_size_option');

// CORNERING LOGIC FOR CUSTOM SIZE
    
    // Check if current shape supports cornering with custom size
    const shapeOption = this.shapeSelect.selectedOptions[0];
    const shapeValue = this.shapeSelect.value;
    const isRectangle = shapeValue === 'rectangle';
    const isSquare = shapeValue === 'square';
    
    // Get allowed corner styles from shape
    const allowedCornerStyles = shapeOption ? shapeOption.dataset.allowedCornerStyles : '';

    // Show cornering for Rectangle/Square custom size
    if ((isRectangle || isSquare) && allowedCornerStyles && allowedCornerStyles.trim() !== '') {
      if (this.cornerStyleFieldContainer) {
        this.cornerStyleFieldContainer.style.display = 'block';
      }
      if (this.cornerStyleSelect) {
        this.cornerStyleSelect.disabled = false;

        // Populate corner styles if not already populated for this shape
        if (this.cornerStyleSelect.options.length <= 1 || 
            this.cornerStyleSelect.dataset.lastPopulatedFor !== shapeValue) {
          this.populateCornerStyles(allowedCornerStyles);
          this.cornerStyleSelect.dataset.lastPopulatedFor = shapeValue;
        }
      }
    } else {
      this.hideCornerStyleField();
    }
      
      // Don't enable quantity yet - wait for valid custom size input
      return;
    } else if (selectedSize && selectedSize !== '') {
      // Standard size selected - hide custom fields if they were shown for custom size option
      if (this.isCustomSizeActive && this.customSizeReason === 'custom_size_option') {
        this.hideCustomSizeFields();

      }
      
      //  Enable quantity selection
      this.quantitySelect.disabled = false;
      this.updateSelectionState(this.quantitySelect);

      this.calculatePriceIfReady();
    } else {

      // Only hide custom fields if they were shown for size option (not custom shape)
      if (this.isCustomSizeActive && this.customSizeReason === 'custom_size_option') {
        this.hideCustomSizeFields();

      }
      this.hideCornerStyleField();

      this.resetQuantitySelection();
      this.calculatePriceIfReady();
    }
    this.emitStateChange('size');
  }
  
  // ========================================
  // UPDATED: SIMPLIFIED QUANTITY CHANGE HANDLER
  // ========================================
  onQuantityChange() {
    var selectedQuantity = this.quantitySelect.value;

    if (selectedQuantity === 'custom') {
      this.showCustomQuantityField();
    } else {
      this.hideCustomQuantityField();
    }

    // Update quantity selection state
    this.updateSelectionState(this.quantitySelect);

    // ✅ SIMPLE: No more print sides repopulation - options are set by material

    this.calculatePriceIfReady();
    this.emitStateChange('quantity');
  }
  
  // ========================================
  // UPDATED: SIMPLIFIED PRINT SIDES CHANGE HANDLER
  // ========================================
  onPrintSidesChange() {
    var selectedSides = this.printSidesSelect.value;
    

    // Update print sides selection state
    this.updateSelectionState(this.printSidesSelect);
    
    // ✅ SIMPLE: Just calculate price - no cascade
    this.calculatePriceIfReady();
    this.emitStateChange('print_sides');
  }
  
  // ========================================
  // UPDATED: SIMPLIFIED PRINT INK CHANGE HANDLER
  // ========================================
  onPrintInkChange() {
    var selectedInk = this.printInkSelect.value;
    

    // Update print ink selection state
    this.updateSelectionState(this.printInkSelect);
    
    // ✅ SIMPLE: Just calculate price - no cascade
    this.calculatePriceIfReady();
    this.emitStateChange('print_ink');
  }
  
  // ========================================
  // NEW: HELPER METHODS FOR SIMPLIFIED APPROACH
  // ========================================
  
  populateAndEnablePrintSides(isFoil) {
    // Preserve existing selection if any
    var previousSelection = this.printSidesSelect.value;
    
    // Clear and populate options based on material
    this.printSidesSelect.innerHTML = '';
    
    if (isFoil) {
      this.printSidesSelect.innerHTML = 
        '<option value="" hidden>Choose Foiled Sides...</option>' +
        '<option value="foil_side_single" data-multiplier="1" data-extra-charge="0">Single</option>' +
        '<option value="foil_side_double" data-multiplier="2" data-extra-charge="1000">Double</option>';
    } else {
      this.printSidesSelect.innerHTML = 
        '<option value="" hidden>Choose Print Sides...</option>' +
        '<option value="print_side_single" data-multiplier="1" data-extra-charge="0">Single Sided</option>' +
        '<option value="print_side_double" data-multiplier="2" data-extra-charge="500">Double Sided</option>';
    }
    
    // Try to restore previous selection if compatible
    if (previousSelection && this.isValidOption(this.printSidesSelect, previousSelection)) {
      this.printSidesSelect.value = previousSelection;

    }
    
    // ✅ ENABLE IMMEDIATELY - no cascade waiting
    this.printSidesSelect.disabled = false;
    this.updateSelectionState(this.printSidesSelect);
    

  }

  populateAndEnablePrintInk(isFoil) {
    // Preserve existing selection if any
    var previousSelection = this.printInkSelect.value;
    
    // Clear existing options
    this.printInkSelect.innerHTML = '';
    
    if (isFoil) {
      // Add foil placeholder
      this.printInkSelect.innerHTML = '<option value="" hidden>Choose Foiled Colour...</option>';
      
      // Add foil colour options from metaobjects
      var foilColours = this.foilColoursData;
      var hasOptions = false;
      var self = this;
      
      Object.keys(foilColours).forEach(function(colourKey) {
        var colour = foilColours[colourKey];
        var option = document.createElement('option');
        option.value = colourKey;
        option.textContent = colour.display_name;
        option.dataset.artworkCharge = colour.artwork_charge;
        option.dataset.doubleSidedFoilingRate = colour.double_sided_foiling_rate;
        option.dataset.perSheetCost = '0.1';
        option.dataset.hexColor = colour.hex_color;
        
        self.printInkSelect.appendChild(option);
        hasOptions = true;
      });
      
      // Fallback foil options if no metaobjects
      if (!hasOptions) {

        var fallbackFoils = [
          { value: 'foil_silver', display: 'Foil (Silver)', hex: '#C0C0C0' },
          { value: 'foil_gold', display: 'Foil (Gold)', hex: '#FFD700' },
          { value: 'foil_copper', display: 'Foil (Copper)', hex: '#B87333' }
        ];
        
        for (var i = 0; i < fallbackFoils.length; i++) {
          var foil = fallbackFoils[i];
          var option = document.createElement('option');
          option.value = foil.value;
          option.textContent = foil.display;
          option.dataset.artworkCharge = '1000';
          option.dataset.doubleSidedFoilingRate = '0.6';
          option.dataset.perSheetCost = '0.1';
          option.dataset.hexColor = foil.hex;
          
          this.printInkSelect.appendChild(option);
        }
      }
    } else {
      // Add regular ink placeholder
      this.printInkSelect.innerHTML = '<option value="" hidden>Choose Print Ink...</option>';
      
      // Add CMYK option (always available)
      var cmykOption = document.createElement('option');
      cmykOption.value = 'ink_cmyk';
      cmykOption.textContent = 'CMYK (Full Colour)';
      cmykOption.dataset.artworkCharge = '1000';
      cmykOption.dataset.perSheetCost = '0.1';
      this.printInkSelect.appendChild(cmykOption);
      
      // Add White Ink option if supported
      var materialOption = this.materialSelect.selectedOptions[0];
      var supportsWhiteInk = materialOption && materialOption.dataset.supportsWhiteInk === 'true';
      
      if (supportsWhiteInk) {
        var whiteInkOption = document.createElement('option');
        whiteInkOption.value = 'ink_white';
        whiteInkOption.textContent = 'White Ink';
        whiteInkOption.dataset.artworkCharge = '1000';
        
        var whiteInkPrice = parseFloat(materialOption.dataset.priceWhiteInk) || 0.4;
        var whiteInkPricePerSheet = whiteInkPrice > 1 ? whiteInkPrice / 100 : whiteInkPrice;
        whiteInkOption.dataset.perSheetCost = whiteInkPricePerSheet.toString();
        
        this.printInkSelect.appendChild(whiteInkOption);

      }
    }
    
    // Try to restore previous selection if compatible
    if (previousSelection && this.isValidOption(this.printInkSelect, previousSelection)) {
      this.printInkSelect.value = previousSelection;

    }
    
    // ✅ ENABLE IMMEDIATELY - no cascade waiting
    this.printInkSelect.disabled = false;
    this.updateSelectionState(this.printInkSelect);
    

  }

  enableOptionalFeaturesForShape(shapeOption) {
    var materialOption = this.materialSelect.selectedOptions[0];

    // Corner styles (if shape supports them)
    var allowedCornerStyles = shapeOption.dataset.allowedCornerStyles;

    if (allowedCornerStyles && allowedCornerStyles.trim() !== '') {
      this.cornerStyleFieldContainer.style.display = 'block';
      this.cornerStyleSelect.disabled = false;

      // Only repopulate if options haven't been populated for this shape yet
      if (this.cornerStyleSelect.options.length <= 1 || this.cornerStyleSelect.dataset.lastPopulatedFor !== shapeOption.value) {
        this.populateCornerStyles(allowedCornerStyles);
        this.cornerStyleSelect.dataset.lastPopulatedFor = shapeOption.value;
      }
    } else {
      this.hideCornerStyleField();
    }
    
    // Drill holes (if shape supports them)
    var allowedDrillDiameters = shapeOption.dataset.allowedDrillDiameters;
    
    if (allowedDrillDiameters && allowedDrillDiameters.trim() !== '') {
      this.drillDiameterFieldContainer.style.display = 'block';
      this.drillDiameterSelect.disabled = false;
      
      // Only repopulate if options haven't been populated for this shape yet
      if (this.drillDiameterSelect.options.length <= 1 || this.drillDiameterSelect.dataset.lastPopulatedFor !== shapeOption.value) {
        this.populateDrillDiameters(allowedDrillDiameters);
        this.drillDiameterSelect.dataset.lastPopulatedFor = shapeOption.value;
      }
      

    } else {
      this.hideDrillHoleFields();

    }
    
    // Eyelets and strings (always available)
    if (this.eyeletSelect) {
      this.eyeletSelect.disabled = false;
    }
    if (this.stringAttachmentSelect) {
      this.stringAttachmentSelect.disabled = false;
    }
    
    // Update states for all optional features
    this.updateAllSelectionStates();
  }

  resetOptionalFeatures() {
    this.resetCornerStyles();
    this.resetDrillHoles();
    this.resetEyelets();
    this.resetStrings();
    this.hideCornerStyleField();
    this.hideDrillHoleFields();
  }

  // ✨ Reset new pricing features
  resetNewPricingFeatures() {
    if (this.multipleDesignsInput) {
      this.multipleDesignsInput.value = 1;
      this.multipleDesignsInput.disabled = true;
    }
    
    if (this.variableDataSelect) {
      this.variableDataSelect.value = 'no';
      this.variableDataSelect.disabled = true;
      this.variableDataMessage.style.display = 'none';
    }
    
    if (this.sequentialNumbersSelect) {
      this.sequentialNumbersSelect.value = 'no';
      this.sequentialNumbersSelect.disabled = true;
      this.sequentialNumbersInput.style.display = 'none';
      this.sequentialRangeInput.value = '';
    }
    
    if (this.perforationCheckbox) {
      this.perforationCheckbox.checked = false;
      this.perforationCheckbox.disabled = true;
    }
    if (this.designMyArtworkCheckbox) {
      this.designMyArtworkCheckbox.checked = false;
      this.designMyArtworkCheckbox.disabled = true;
    }
    

  }

  calculatePriceIfReady() {
    // Check if we have all required fields for pricing
    var materialOption = this.materialSelect.selectedOptions[0];
    var shapeValue = this.shapeSelect.value;
    var sizeOption = this.sizeSelect.selectedOptions[0];
    var quantity = this.getCurrentQuantity();
    
    var hasMaterial = materialOption && materialOption.value;
    var hasShape = shapeValue;
    var hasQuantity = quantity > 0;
    var hasPrintSides = this.printSidesSelect.value && this.printSidesSelect.value !== '';
    var hasPrintInk = this.printInkSelect.value && this.printInkSelect.value !== '';
    
    // Check size requirements - handle both custom shape and custom size option
    var hasSize = false;
    if (shapeValue === 'custom' || this.sizeSelect.value === 'custom_size') {
      hasSize = this.hasValidCustomSize();
    } else {
      hasSize = sizeOption && sizeOption.value;
    }
    
    
    if (hasMaterial && hasShape && hasSize && hasQuantity && hasPrintSides && hasPrintInk) {

      this.calculatePrice();
      this.showPriceDisplay();
    } else {

      this.hidePriceDisplay();
    }
  }

  // Helper method to check if option value exists in select
  isValidOption(selectElement, value) {
    for (var i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].value === value) {
        return true;
      }
    }
    return false;
  }

  // ========================================
  //  OPTIONAL FEATURE HANDLERS
  // ========================================
  
  onCornerStyleChange() {
    var selectedStyle = this.cornerStyleSelect.value;

    this.updateSelectionState(this.cornerStyleSelect);
    this.calculatePriceIfReady();
  }
  
  // Handle drill diameter change
  onDrillDiameterChange() {
    // Defence-in-depth: eyelets physically require a 4mm drill hole. If an eyelet
    // is selected and any other diameter slips through, snap back to 4mm first.
    if (this.isEyeletSelected() && this.drillDiameterSelect.value !== '4') {
      var has4mm = Array.from(this.drillDiameterSelect.options)
        .some(function(o) { return o.value === '4'; });
      if (has4mm) {
        this.drillDiameterSelect.value = '4';
      }
    }

    var selectedDiameter = this.drillDiameterSelect.value;
    

    if (selectedDiameter && selectedDiameter !== '' && selectedDiameter !== '0') {
      this.enableDrillPositionSelection();
    } else {
      this.hideDrillPositionField();
      this.resetDrillPosition();
    }
    
    this.updateSelectionState(this.drillDiameterSelect);
    this.calculatePriceIfReady();
  }
  
  // Handle drill position change
  onDrillPositionChange() {
    var selectedPosition = this.drillPositionSelect.value;

    this.updateSelectionState(this.drillPositionSelect);
    this.calculatePriceIfReady();
  }
  
  // Eyelet functionality
  onEyeletChange() {
    var selectedEyelet = this.eyeletSelect.value;

    // Refresh drill diameters for ALL shapes — an eyelet requires a 4mm drill hole
    // regardless of shape, so the dropdown must re-restrict whenever the eyelet changes.
    this.refreshDrillDiameters();

    this.updateSelectionState(this.eyeletSelect);
    this.calculatePriceIfReady();
  }
  
  //  STRING ATTACHMENT CALCULATION
  onStringAttachmentChange() {
    var selectedValue = this.stringAttachmentSelect.value;
    var selectedOption = this.stringAttachmentSelect.selectedOptions[0];
    

    var isNoneType = !selectedValue || 
                       selectedValue === '' || 
                       selectedValue === 'string_attachment_none' ||
                       selectedValue.toLowerCase().includes('none') ||
                       selectedValue === 'none';
    
    if (!isNoneType) {
      if (this.stringTypeFieldContainer) {
        this.stringTypeFieldContainer.style.display = 'block';
      }
      if (this.stringTypeSelect) {
        this.stringTypeSelect.disabled = false;
      }

    } else {
      if (this.stringTypeFieldContainer) {
        this.stringTypeFieldContainer.style.display = 'none';
      }
      if (this.stringTypeSelect) {
        this.stringTypeSelect.disabled = true;
        this.stringTypeSelect.value = '';
      }

    }
    
    this.updateSelectionState(this.stringAttachmentSelect);
    this.calculatePriceIfReady();
  }
  
  onStringTypeChange(){ 

    this.updateSelectionState(this.stringTypeSelect);
    this.calculatePriceIfReady(); 
  }

  //  Update custom size constraints based on selected material and cutting method
  //  Update custom size constraints based on selected material and cutting method
updateCustomSizeConstraints() {
  var materialOption = this.materialSelect.selectedOptions[0];
  var shapeOption = this.shapeSelect.selectedOptions[0];
  
  if (!materialOption) return;

  var minSize = parseInt(materialOption.dataset.minSize) || 20;
  var bleedAddition = this.pricingConstants.bleed_addition || 4;
  
  // Get sheet dimensions based on cutting method
  var sheetDimensions = this.getSheetDimensions(shapeOption ? shapeOption.value : '');
  var materialWidth = sheetDimensions.width;
  var materialHeight = sheetDimensions.height;
  
  var maxWidth, maxHeight, constraintType;
  
  // Determine cutting method and apply appropriate constraints
  if (shapeOption && (shapeOption.value === 'rectangle' || shapeOption.value === 'square')) {
    // GUILLOTINE CUTTING: Calculate max dimensions that fit at least 1 tag on sheet
    constraintType = 'guillotine (434×304mm sheet)';
    
    // Calculate maximum tag dimensions considering bleed
    // For at least 1 tag: (tag_width + bleed) ≤ sheet_width AND (tag_height + bleed) ≤ sheet_height
    maxWidth = materialWidth - bleedAddition;
    maxHeight = materialHeight - bleedAddition;
    
    // Also check landscape orientation possibilities
    var maxWidthLandscape = materialHeight - bleedAddition;
    var maxHeightLandscape = materialWidth - bleedAddition;
    
    // Use the more permissive constraints (allows for better layout optimization)
    maxWidth = Math.max(maxWidth, maxWidthLandscape);
    maxHeight = Math.max(maxHeight, maxHeightLandscape);
    
  } else {
    // DIGITAL DIE-CUTTING: Simple material sheet limits
    constraintType = 'digital (426×296mm sheet)';
    maxWidth = materialWidth;
    maxHeight = materialHeight;
  }

  // Update input constraints
  this.customWidthInput.min = minSize;
  this.customWidthInput.max = Math.floor(maxWidth);
  this.customHeightInput.min = minSize;
  this.customHeightInput.max = Math.floor(maxHeight);

  // Update constraint text - show clear warnings for custom shapes
  if (shapeOption && shapeOption.value === 'custom') {
    // For custom shapes: show warning format
    if (this.widthConstraint) {
      this.widthConstraint.textContent = 'Width cannot exceed ' + Math.floor(maxWidth) + 'mm';
    }
    if (this.heightConstraint) {
      this.heightConstraint.textContent = 'Height cannot exceed ' + Math.floor(maxHeight) + 'mm';
    }
  } else {
    // For other shapes: show min/max with cutting method info
    var methodNote = ' (' + constraintType + ')';
    if (this.widthConstraint) {
      this.widthConstraint.textContent = 'Min: ' + minSize + 'mm, Max: ' + Math.floor(maxWidth) + 'mm' + methodNote;
    }
    if (this.heightConstraint) {
      this.heightConstraint.textContent = 'Min: ' + minSize + 'mm, Max: ' + Math.floor(maxHeight) + 'mm' + methodNote;
    }
  }

}

  //  Validate custom size against material constraints and cutting method
  //  Validate custom size against material constraints and cutting method
validateCustomSize() {
  if (!this.isCustomSizeActive) {

    return true;
  }

  var width = parseFloat(this.customWidthInput.value) || 0;
  var height = parseFloat(this.customHeightInput.value) || 0;
  var materialOption = this.materialSelect.selectedOptions[0];
  var shapeOption = this.shapeSelect.selectedOptions[0];

  if (!materialOption) {

    return false;
  }

  if (width <= 0 || height <= 0) {

    if (this.sizeValidation) {
      this.sizeValidation.innerHTML = '<strong>Please enter valid width and height values</strong>';
      this.sizeValidation.style.display = 'block';
      this.sizeValidation.style.color = '#d73527';
    }
    return false;
  }

  var minSize = parseInt(materialOption.dataset.minSize) || 20;
  var bleedAddition = this.pricingConstants.bleed_addition || 4;
  
  // Get sheet dimensions based on cutting method
  var sheetDimensions = this.getSheetDimensions(shapeOption ? shapeOption.value : '');
  var materialWidth = sheetDimensions.width;
  var materialHeight = sheetDimensions.height;

  var errors = [];

  // Check minimum size
  if (width < minSize) errors.push('Width must be at least ' + minSize + 'mm');
  if (height < minSize) errors.push('Height must be at least ' + minSize + 'mm');

  // Check maximum size based on cutting method
  if (shapeOption && (shapeOption.value === 'rectangle' || shapeOption.value === 'square')) {
    // GUILLOTINE CUTTING: Check if tag fits on sheet with bleed in either orientation
    var fitsPortrait = (width + bleedAddition <= materialWidth) && (height + bleedAddition <= materialHeight);
    var fitsLandscape = (width + bleedAddition <= materialHeight) && (height + bleedAddition <= materialWidth);
    
    if (!fitsPortrait && !fitsLandscape) {
      errors.push('Tag dimensions with bleed (' + (width + bleedAddition) + 'mm × ' + (height + bleedAddition) + 'mm) must fit on ' + materialWidth + 'mm × ' + materialHeight + 'mm guillotine sheet in at least one orientation');
    }
    
    // Additional check: ensure we get at least 1 tag per sheet
    var tagsPortrait = this.calculateTagsPerSheet(width, height, materialWidth, materialHeight);
    var tagsLandscape = this.calculateTagsPerSheet(height, width, materialWidth, materialHeight); // Swapped dimensions
    
    if (tagsPortrait < 1 && tagsLandscape < 1) {
      errors.push('Tag dimensions too large - no tags would fit on guillotine sheet');
    }
    
  } else {
    // DIGITAL DIE-CUTTING: Simple material sheet constraints
    if (width > materialWidth) errors.push('Width cannot exceed digital die-cut sheet width (' + materialWidth + 'mm)');
    if (height > materialHeight) errors.push('Height cannot exceed digital die-cut sheet height (' + materialHeight + 'mm)');
  }

  // Display validation
  if (errors.length > 0) {

    if (this.sizeValidation) {
      this.sizeValidation.innerHTML = '<strong>Size validation errors:</strong><br>' + errors.join('<br>');
      this.sizeValidation.style.display = 'block';
      this.sizeValidation.style.color = '#d73527';
    }
    return false;
  } else {

    if (this.sizeValidation) {
      this.sizeValidation.style.display = 'none';
    }
    return true;
  }
}
  
  onCustomQuantityChange() {
    var self = this;
    clearTimeout(this.customQuantityTimeout);
    this.customQuantityTimeout = setTimeout(function() {
      self.calculatePriceIfReady();
    }, 300);
  }
  
  //  Handle custom size changes for both custom shape and custom size option
  onCustomSizeChange() {
    var self = this;
    clearTimeout(this.customSizeTimeout);
    this.customSizeTimeout = setTimeout(function() {
      var width = parseFloat(self.customWidthInput.value) || 0;
      var height = parseFloat(self.customHeightInput.value) || 0;
      
      // Validate against material constraints
      var isValid = self.validateCustomSize();
      
      if (width > 0 && height > 0 && isValid) {
        self.quantitySelect.disabled = false;
        self.updateSelectionState(self.quantitySelect);

      } else {
        self.resetQuantitySelection();

      }
      
      self.calculatePriceIfReady();
    }, 300);
  }
  
  // ═══════════════════════════════════════════════════════════════════════════════════════
  // 🚀 Universal Sheet Calculator
  // ═══════════════════════════════════════════════════════════════════════════════════════
  
  calculateUniversalOptimizedSheets(width, height, quantity, shapeValue, sizeOption) {
  // Get sheet dimensions based on cutting method
  var sheetDimensions = this.getSheetDimensions(shapeValue);
  var materialWidth = sheetDimensions.width;
  var materialHeight = sheetDimensions.height;
  
  // Get dimensions for calculation
  var tagWidth, tagHeight;
  
  if (shapeValue === 'custom' || this.sizeSelect.value === 'custom_size') {
    // Custom dimensions from input fields
    tagWidth = parseFloat(this.customWidthInput.value);
    tagHeight = parseFloat(this.customHeightInput.value);
    
  } else if (sizeOption && sizeOption.dataset) {
    // Template dimensions from metaobject data
    tagWidth = parseFloat(sizeOption.dataset.width);
    tagHeight = parseFloat(sizeOption.dataset.height);
    
  } else {
    console.error('⚠️ No dimensions available for calculation');
    return { 
      sheetsNeeded: Math.ceil(quantity / 1), 
      tagsPerSheet: 1, 
      orientation: 'error'
    };
  }
  
  // UNIFIED CALCULATION: Use same optimization logic for ALL sizes
  if (shapeValue === 'rectangle' || shapeValue === 'square') {
    // GUILLOTINE CUTTING: Optimize orientation for rectangles/squares
    var optimalLayout = this.calculateOptimalTagsPerSheet(tagWidth, tagHeight, materialWidth, materialHeight);
    var sheetsNeeded = Math.ceil(quantity / optimalLayout.tagsPerSheet);
    
    // Calculate both orientations for transparency
    var portraitTags = this.calculateTagsPerSheet(tagWidth, tagHeight, materialWidth, materialHeight);
    var landscapeTags = this.calculateTagsPerSheet(tagHeight, tagWidth, materialWidth, materialHeight);
    var portraitSheets = Math.ceil(quantity / portraitTags);
    var landscapeSheets = Math.ceil(quantity / landscapeTags);
    
    
    return {
      sheetsNeeded: sheetsNeeded,
      tagsPerSheet: optimalLayout.tagsPerSheet,
      orientation: optimalLayout.orientation,
      portraitTagsPerSheet: portraitTags,
      landscapeTagsPerSheet: landscapeTags,
      portraitSheetsNeeded: portraitSheets,
      landscapeSheetsNeeded: landscapeSheets
    };
  } else {
    // DIGITAL DIE-CUTTING: Optimize orientation for rounds/ovals/custom
    var portraitTags = this.calculateTagsPerSheet(tagWidth, tagHeight, materialWidth, materialHeight);
    var landscapeTags = this.calculateTagsPerSheet(tagHeight, tagWidth, materialWidth, materialHeight);
    var portraitSheets = Math.ceil(quantity / portraitTags);
    var landscapeSheets = Math.ceil(quantity / landscapeTags);
    
    var optimalTagsPerSheet = Math.max(portraitTags, landscapeTags);
    var optimalOrientation = landscapeTags > portraitTags ? 'landscape' : 'portrait';
    var sheetsNeeded = Math.ceil(quantity / optimalTagsPerSheet);
    
    
    return {
      sheetsNeeded: sheetsNeeded,
      tagsPerSheet: optimalTagsPerSheet,
      orientation: optimalOrientation,
      portraitTagsPerSheet: portraitTags,
      landscapeTagsPerSheet: landscapeTags,
      portraitSheetsNeeded: portraitSheets,
      landscapeSheetsNeeded: landscapeSheets
    };
  }
}

  optimizeCustomSizeOrientation(width, height, materialWidth, materialHeight, quantity, shapeValue) {
    // Calculate both orientations for transparency
    var portraitTags = this.calculateTagsPerSheet(width, height, materialWidth, materialHeight);
    var landscapeTags = this.calculateTagsPerSheet(height, width, materialWidth, materialHeight);
    var portraitSheets = Math.ceil(quantity / portraitTags);
    var landscapeSheets = Math.ceil(quantity / landscapeTags);
    
    // For rectangles/squares: use existing optimized method (already checks both orientations)
    if (shapeValue === 'rectangle' || shapeValue === 'square') {
      var optimalLayout = this.calculateOptimalTagsPerSheet(width, height, materialWidth, materialHeight);
      var sheetsNeeded = Math.ceil(quantity / optimalLayout.tagsPerSheet);
      
      // Calculate potential savings
      var worstOrientation = optimalLayout.orientation === 'portrait' ? landscapeTags : portraitTags;
      var worstSheets = Math.ceil(quantity / worstOrientation);
      var sheetsSaved = worstSheets - sheetsNeeded;
      
      
      return {
        sheetsNeeded: sheetsNeeded,
        tagsPerSheet: optimalLayout.tagsPerSheet,
        orientation: optimalLayout.orientation,
        // Include both calculations for transparency
        portraitTagsPerSheet: portraitTags,
        landscapeTagsPerSheet: landscapeTags,
        portraitSheetsNeeded: portraitSheets,
        landscapeSheetsNeeded: landscapeSheets
      };
    }
    
    // 🚀 NEW OPTIMIZATION: For rounds/ovals/custom shapes
    else {
      var optimalTagsPerSheet = Math.max(portraitTags, landscapeTags);
      var optimalOrientation = landscapeTags > portraitTags ? 'landscape' : 'portrait';
      var sheetsNeeded = Math.ceil(quantity / optimalTagsPerSheet);
      
      // Calculate savings
      var worstTagsPerSheet = Math.min(portraitTags, landscapeTags);
      var worstSheets = Math.ceil(quantity / worstTagsPerSheet);
      var sheetsSaved = worstSheets - sheetsNeeded;
      var percentageSaved = worstTagsPerSheet > 0 ? 
        ((sheetsSaved / worstSheets) * 100).toFixed(1) : 0;
      
      
      return {
        sheetsNeeded: sheetsNeeded,
        tagsPerSheet: optimalTagsPerSheet,
        orientation: optimalOrientation,
        // Include both calculations for transparency
        portraitTagsPerSheet: portraitTags,
        landscapeTagsPerSheet: landscapeTags,
        portraitSheetsNeeded: portraitSheets,
        landscapeSheetsNeeded: landscapeSheets
      };
    }
  }
  
  // ═══════════════════════════════════════════════════════════════════════════════════════
  // 🚀 OPTIMIZED: Price Calculation with Single Sheet Calculation + NEW FEATURES
  // ═══════════════════════════════════════════════════════════════════════════════════════
  
  calculatePrice() {
    var materialOption = this.materialSelect.selectedOptions[0];
    var shapeValue = this.shapeSelect.value;
    var sizeOption = this.sizeSelect.selectedOptions[0];
    var quantity = this.getCurrentQuantity();
    var stringCost = this.calculateStringCost(quantity);
    var isFoil = this.isFoilMaterial();
    var supportsWhiteInk = this.materialSelect.selectedOptions[0] ? this.materialSelect.selectedOptions[0].dataset.supportsWhiteInk === 'true' : false;
    
    // ✨ NEW: Calculate new pricing features ✨
    var multipleDesignsCost = this.calculateMultipleDesignsCost();
    var variableDataCost = this.calculateVariableDataCost();
    var sequentialNumbersCost = this.calculateSequentialNumbersCost();
    var perforationCost = this.calculatePerforationCost(quantity);
    var designMyArtworkCost = this.calculateDesignMyArtworkCost();
    

    //  Enhanced validation - check all visible fields are completed
    var hasMaterial = materialOption && materialOption.value;
    var hasShape = shapeValue;
    var hasQuantity = quantity > 0;
    var hasPrintSides = this.printSidesSelect.value && this.printSidesSelect.value !== '';
    var hasPrintInk = this.printInkSelect.value && this.printInkSelect.value !== '';
    
    //  Check size requirements - handle both custom shape and custom size option
    var hasSize = false;
    if (shapeValue === 'custom' || this.sizeSelect.value === 'custom_size') {
      hasSize = this.hasValidCustomSize();
    } else {
      hasSize = sizeOption && sizeOption.value;
    }
    
    //  Debug validation state
    
    if (!hasMaterial || !hasShape || !hasSize || !hasQuantity || !hasPrintSides || !hasPrintInk) {

      this.hidePriceDisplay();
      this.dispatchCalculatorEvent('ht-calculator-reset');
      this.dispatchCalculatorEvent('ht-calculator-ready', { isReady: false });
      return;
    }
    

    // Parse material pricing data
    var baseCostRaw = materialOption.dataset.baseCost;
    var setupCostRaw = materialOption.dataset.setupCost;
    
    var baseCostPence = this.parsePrice(baseCostRaw) || 0;
    var baseCostPer1000Sheets = baseCostPence / 100;
    
    var setupCostPence = this.parsePrice(setupCostRaw) || 0;
    var materialSetupCost = setupCostPence / 100;
    
    // Get sheet dimensions based on cutting method (CHANGED)
    var sheetDimensions = this.getSheetDimensions(shapeValue);
    var materialWidth = sheetDimensions.width;
    var materialHeight = sheetDimensions.height;

    
    // Parse print sides and ink data
    var printSidesOption = hasPrintSides ? this.printSidesSelect.selectedOptions[0] : null;
    var printInkOption = hasPrintInk ? this.printInkSelect.selectedOptions[0] : null;
    
    var printSidesMultiplier = hasPrintSides ? (parseFloat(printSidesOption.dataset.multiplier) || 1) : 1;
    var printSidesExtraChargePence = hasPrintSides ? this.parsePrice(printSidesOption.dataset.extraCharge) || 0 : 0;
    var printSidesExtraCharge = printSidesExtraChargePence / 100;
    
    var inkArtworkChargePence = hasPrintInk ? this.parsePrice(printInkOption.dataset.artworkCharge) || 1000 : 1000;
    var inkArtworkCharge = inkArtworkChargePence / 100;
    
    // Get custom dimensions if applicable
    var customWidth = 0, customHeight = 0;
    if (shapeValue === 'custom' || this.sizeSelect.value === 'custom_size') {
      customWidth = parseFloat(this.customWidthInput.value);
      customHeight = parseFloat(this.customHeightInput.value);
    }
    
    // 🚀 SINGLE UNIVERSAL CALCULATION - replaces 3 duplicate calculations
    var optimizedSheets = this.calculateUniversalOptimizedSheets(
  customWidth, 
  customHeight, 
  quantity, 
  shapeValue, 
  sizeOption
);
    
    var sheetsNeeded = optimizedSheets.sheetsNeeded;
    var tagsPerSheet = optimizedSheets.tagsPerSheet;
    
    
    //  SEPARATED foil and white ink specific pricing
    var foilSetupCost = 0;
    var doubleSidedFoilingCost = 0;
    var whiteInkSurcharge = 0;
    var inkPerSheetCost = 0.1; // Default CMYK rate
    var isWhiteInk = false;
    
    if (isFoil && hasPrintInk) {
      // Add foil setup cost (£30)
      foilSetupCost = 30;
      
      // Use foil printing rate (same as CMYK - £0.1 per sheet)
      var priceCmykFoilRaw = materialOption.dataset.priceCmykFoil || '0.1';
      inkPerSheetCost = parseFloat(priceCmykFoilRaw) > 1 ? parseFloat(priceCmykFoilRaw) / 100 : parseFloat(priceCmykFoilRaw);
      
      // Add double-sided foiling cost if double-sided is selected
      if (printSidesOption && printSidesOption.value === 'foil_side_double') {
        var doubleSidedRate = parseFloat(printInkOption.dataset.doubleSidedFoilingRate) || 0.60;
        
        // 🚀 OPTIMIZED: Use already calculated sheets (no duplicate calculation)
        doubleSidedFoilingCost = this.roundToPence(sheetsNeeded * doubleSidedRate);
        
      }
      
    } else if (hasPrintInk) {
      // Check if white ink is selected
      isWhiteInk = printInkOption.value === 'ink_white';
      
      if (isWhiteInk && supportsWhiteInk) {
        // WHITE INK: Separate base CMYK cost from white ink surcharge
        var whiteInkRateRaw = parseFloat(printInkOption.dataset.perSheetCost) || 0.4;
        var whiteInkRate = whiteInkRateRaw > 1 ? whiteInkRateRaw / 100 : whiteInkRateRaw;
        var cmykRate = 0.1; // Standard CMYK rate
        
        // Base cost uses CMYK rate, surcharge is the difference
        inkPerSheetCost = cmykRate;
        var whiteInkSurchargePerSheet = whiteInkRate - cmykRate;
        
        // 🚀 OPTIMIZED: Use already calculated sheets (no duplicate calculation)
        whiteInkSurcharge = this.roundToPence(whiteInkSurchargePerSheet * sheetsNeeded * printSidesMultiplier);
        
      } else {
        // Regular CMYK pricing
        var inkPerSheetCostRaw = parseFloat(printInkOption.dataset.perSheetCost) || 0.1;
        inkPerSheetCost = inkPerSheetCostRaw > 1 ? inkPerSheetCostRaw / 100 : inkPerSheetCostRaw;
      }
    }
    
    // Calculate material and printing costs SEPARATELY for detailed breakdown
var materialPricePerSheet = Number((baseCostPer1000Sheets / 1000).toFixed(3));

// The double-sided aspect only affects the foiling surcharge
var effectivePrintMultiplier = printSidesMultiplier;
var printingPricePerSheet = inkPerSheetCost * effectivePrintMultiplier;

// Calculate individual costs SEPARATELY for detailed breakdown
var materialCost = this.roundToPence(materialPricePerSheet * sheetsNeeded);
var printingCost = this.roundToPence(printingPricePerSheet * sheetsNeeded);
    var basePriceTotal = this.roundToPence(materialCost + printingCost);

    // Calculate cutting charges
    var isCustomSize = shapeValue === 'custom' || this.sizeSelect.value === 'custom_size';
    var cuttingCharge = this.calculateCuttingCharge(shapeValue, isCustomSize, quantity, materialOption, sheetsNeeded);
    
    // Calculate other costs
    // Block cornering only for custom die-cut shapes
const isCustomDieCutShape = shapeValue === 'custom';
const shouldBlockCornering = isCustomDieCutShape;

var cornerStyleCost = shouldBlockCornering ? 
  { setup: 0, perQuantity: 0, total: 0 } : 
  this.calculateCornerStyleCost(quantity);

if (isCustomDieCutShape) {

}
    var drillHoleCost = this.calculateDrillHoleCost(quantity);
    var eyeletCost = this.calculateEyeletCost(quantity);
    var serviceCharge = this.calculateServiceCharge();
    var deliveryCharge = (this.pricingConstants.delivery_charge || 695) / 100; // Convert to pounds
    
    //  ✅ Separate double-sided printing cost from base setup costs
    var doubleSidedPrintingCost = printSidesExtraCharge; // Extract this separately
    
    // ✅ For foil materials, exclude materialSetupCost to avoid double-charging
    // (foilSetupCost already covers material preparation)
    var baseSetupCost;
    if (isFoil) {
      baseSetupCost = inkArtworkCharge; // Only artwork setup for foil materials

    } else {
      baseSetupCost = materialSetupCost + inkArtworkCharge; // Include material setup for regular materials

    }
    
    var totalFoilingCosts = foilSetupCost + doubleSidedFoilingCost;

    // Calculate total new pricing features cost 
    var totalNewFeaturesCost = this.roundToPence(multipleDesignsCost.total + 
                           variableDataCost.total + 
                           sequentialNumbersCost.total + 
                           perforationCost.total + 
                           designMyArtworkCost.total);
    
    
    //  Total calculation with separated double-sided printing costs + FEATURES
    var netTotal = this.roundToPence(basePriceTotal + 
           cuttingCharge.total + 
           cornerStyleCost.total + 
           drillHoleCost.total + 
           eyeletCost.total + 
           stringCost.total + 
           whiteInkSurcharge +
           baseSetupCost +
           doubleSidedPrintingCost +
           totalFoilingCosts +
           serviceCharge.total +
           deliveryCharge +
           totalNewFeaturesCost);

    // Apply markup and VAT
    var markupRate = this.pricingConstants.markup_percentage / 100 || 0;
   var markupAmount = this.roundToPence(netTotal * markupRate);
var priceExclVAT = this.roundToPence(netTotal + markupAmount);
var vatAmount = this.roundToPence(priceExclVAT * 0.20);
var priceInclVAT = this.roundToPence(priceExclVAT + vatAmount);
var finalPricePerTag = this.roundToPence(priceInclVAT / quantity);

    // Store pricing data for state manager (ex-VAT pipeline)
    this.lastPricingData = {
      priceExclVAT: priceExclVAT,
      vatAmount: vatAmount,
      priceInclVAT: priceInclVAT,
      quantity: quantity
    };

    // Basic price display only (no detailed breakdown)
    this.updateSimplePriceDisplay(priceInclVAT, finalPricePerTag);
    this.showPriceDisplay();
    
    // 🚀 Dispatch comprehensive pricing data for external components
this.dispatchPricingData({
  materialCost, printingCost, sheetsNeeded, cuttingCharge, cornerStyleCost,
  drillHoleCost, eyeletCost, stringCost, whiteInkSurcharge, serviceCharge,
  deliveryCharge, netTotal, finalPricePerTag, quantity, isWhiteInk, isFoilMaterial: isFoil,
  orientationData: optimizedSheets, multipleDesignsCost, variableDataCost,
  sequentialNumbersCost, perforationCost, designMyArtworkCost,
  materialSetupCost: materialSetupCost,     
  artworkSetupCost: inkArtworkCharge,          // £10.00 - artwork preparation  
  baseSetupCost, doubleSidedPrintingCost: printSidesExtraCharge,
  totalFoilingCosts, markupRate, markupAmount, priceExclVAT, vatAmount, priceInclVAT
});
    this.dispatchCalculatorEvent('ht-calculator-ready', { isReady: true });
    
    // 🚀 PHASE 1B: Emit calculator complete event when calculation succeeds
    document.dispatchEvent(new CustomEvent('calculator:complete', {
      detail: { 
        calculatorType: 'regular',
        isValid: true,
        pricing: this.getCurrentPricing()
      }
    }));
  }

  // 🚀 Dispatch pricing data for external components (like pricing breakdown)
  dispatchPricingData(pricingData) {
    this.dispatchCalculatorEvent('ht-pricing-calculated', pricingData);
  }

  // Basic price display only (no detailed breakdown)
  updateSimplePriceDisplay(totalPrice, pricePerTag) {
    if (this.totalPriceDisplay) {
      this.totalPriceDisplay.textContent = this.formatPrice(totalPrice);
    }
    if (this.pricePerTagDisplay) {
      this.pricePerTagDisplay.textContent = this.formatPrice(pricePerTag);
    }
  }
  
  calculateTagsPerSheet(customWidth, customHeight, materialWidth, materialHeight) {
    var bleedAddition = this.pricingConstants.bleed_addition || 4;

    var effectiveWidth = customWidth + bleedAddition;
    var effectiveHeight = customHeight + bleedAddition;

    var tagsPerRow = Math.floor(materialWidth / effectiveWidth);
    var tagsPerColumn = Math.floor(materialHeight / effectiveHeight);
    var totalTagsPerSheet = tagsPerRow * tagsPerColumn;

    return Math.max(1, totalTagsPerSheet);
  }

  //  Calculate optimal tags per sheet considering both orientations
  calculateOptimalTagsPerSheet(customWidth, customHeight, materialWidth, materialHeight) {
    // Calculate for both orientations
    var tagsPortrait = this.calculateTagsPerSheet(customWidth, customHeight, materialWidth, materialHeight);
    var tagsLandscape = this.calculateTagsPerSheet(customHeight, customWidth, materialWidth, materialHeight);
    
    // Return the better orientation
    if (tagsLandscape > tagsPortrait) {
      return {
        tagsPerSheet: tagsLandscape,
        orientation: 'landscape',
        tagWidth: customHeight,  // Swapped
        tagHeight: customWidth   // Swapped
      };
    } else {
      return {
        tagsPerSheet: tagsPortrait,
        orientation: 'portrait',
        tagWidth: customWidth,
        tagHeight: customHeight
      };
    }
  }

//  ✅ : Cutting charge calculation with EXCEL-ACCURATE guillotine method
calculateCuttingCharge(shapeHandle, isCustomSize, quantity, materialOption, sheetsNeeded) {
  var constants = this.pricingConstants;
  
  
  // ━━━ PATH 1: RECTANGLE/SQUARE → GUILLOTINE CUTTING METHOD ━━━━━━━━━━━━━━━━━━━━━━━━
  if (shapeHandle === 'rectangle' || shapeHandle === 'square') {
    // ✅ FIX 1: Convert money field from pence to pounds
    var setupCharge = (constants.guillotine_setup_charge || 1000) / 100; 
    var cuttingRate = constants.guillotine_cutting_rate || 45;
    var materialGsm = parseFloat(materialOption ? materialOption.dataset.gsmOrMic : null) || 300;
    
    // STEP 1: Calculate guillotine_calc1 (Weight-Adjusted Batch Factor)
    var cuttingPile = constants.guillotine_cutting_pile || 100;
    var defaultCuttingWeight = constants.guillotine_cutting_weight || 300;
    var guillotine_calc1 = Math.ceil((sheetsNeeded / cuttingPile) * (materialGsm / defaultCuttingWeight));
    
    // STEP 2: Calculate guillotine_calc2 (Time in Hours)
    // 🔧 FIX: ALWAYS calculate tagsPerSheet dynamically (no presets)
    
    // STEP 2.1: Get sheet dimensions based on cutting method (CRITICAL!)
    var sheetDimensions = this.getSheetDimensions(shapeHandle);
    var materialWidth = sheetDimensions.width;
    var materialHeight = sheetDimensions.height;
    
    // STEP 2.2: Get tag dimensions
    var tagWidth, tagHeight;
    
    if (shapeHandle === 'custom' || this.sizeSelect.value === 'custom_size') {
      // Custom size: get from input fields
      tagWidth = parseFloat(this.customWidthInput.value);
      tagHeight = parseFloat(this.customHeightInput.value);
    } else {
      // Standard size: parse dimensions from dropdown data attributes
      var sizeOption = this.sizeSelect.selectedOptions[0];
      tagWidth = parseFloat(sizeOption?.dataset.width) || 50;
      tagHeight = parseFloat(sizeOption?.dataset.height) || 100;
    }
    
    // STEP 2.3: ALWAYS calculate optimal tags per sheet (never use preset)
    var tagsPerSheet;
    if (shapeHandle === 'rectangle' || shapeHandle === 'square') {
      var optimalLayout = this.calculateOptimalTagsPerSheet(tagWidth, tagHeight, materialWidth, materialHeight);
      tagsPerSheet = optimalLayout.tagsPerSheet;
    } else {
      tagsPerSheet = this.calculateTagsPerSheet(tagWidth, tagHeight, materialWidth, materialHeight);
    }
    
    
    var cutsPerHour = constants.guillotine_cuts_per_hour || 120;
    var guillotine_calc2 = guillotine_calc1 * (tagsPerSheet / cutsPerHour);
    
    // STEP 3: Calculate the Base Cutting Cost (no minimum applied)
    var baseCuttingCost = guillotine_calc2 * cuttingRate;
    
    // ✅ Use actual calculated cost, not minimum
    var timeCost = baseCuttingCost; // Removed: Math.max(baseCuttingCost, minimumCharge);
    var totalCost = timeCost + setupCharge;
    
    
    return {
      setup: setupCharge,
      perQuantity: timeCost,  // This is now the actual calculated cost
      total: totalCost,
      calculation: 'guillotine_calc1 (' + sheetsNeeded + ' sheets ÷ ' + cuttingPile + ' pile × ' + materialGsm + 'gsm ÷ ' + defaultCuttingWeight + 'gsm) = ' + guillotine_calc1 + 
             ' || guillotine_calc2 (' + guillotine_calc1 + ' × ' + tagsPerSheet + ' tags ÷ ' + cutsPerHour + ' cuts/hr) = ' + guillotine_calc2.toFixed(2) + 'h + £' + setupCharge.toFixed(2) + ' setup'
    };
    
  // ━━━ PATH 2: DIGITAL DIE-CUTTING → SETUP + PER-TAG CUTTING ━━━━━━━━━━━━━━━━━━━━━━
  } else {
    var constants = this.pricingConstants;
    
    // Setup charge: £10
    var setupCostPence = constants.digital_die_cut_setup_charge || 1000;
    var setupCost = setupCostPence / 100;
    
    // Per-tag cutting charge: £0.02 per tag
    var perTagCuttingCost = (constants.digital_die_cut_per_cut_charge || 2) / 100; 
    var totalCuttingCost = quantity * perTagCuttingCost;
    
    var totalCost = setupCost + totalCuttingCost;
    
    
    return {
      setup: setupCost,
      perQuantity: totalCuttingCost,
      total: totalCost,
      calculation: '£' + setupCost + ' setup + ' + quantity + ' tags × £' + perTagCuttingCost + ' = £' + totalCost.toFixed(2)
    };
  }
}

  calculateCornerStyleCost(quantity) {
    if (!this.cornerStyleSelect || !this.cornerStyleSelect.value) {
      return { setup: 0, perQuantity: 0, total: 0, calculation: '' };
    }
    
    var cornerStyleOption = this.cornerStyleSelect.selectedOptions[0];
    var pricePerThousandPence = parseInt(cornerStyleOption.dataset.pricePerThousand) || 0;
    var setupChargePence = parseInt(cornerStyleOption.dataset.setupCharge) || 0;

  if (pricePerThousandPence === 0 && setupChargePence === 0) {
    return { 
      setup: 0, 
      perQuantity: 0, 
      total: 0, 
      calculation: 'No charge',
      name: cornerStyleOption.textContent || 'Corner style'
    };
  }
    
    var pricePerThousand = pricePerThousandPence / 100;
    var setupCharge = setupChargePence / 100;
    
    var quantityCost = (quantity / 1000) * pricePerThousand;
    var total = setupCharge + quantityCost;
    
    var styleName = cornerStyleOption.textContent || 'Corner style';
    var calculation = '£' + setupCharge + ' setup + ' + quantity + ' × £' + pricePerThousand + '/1000';
    
    return { setup: setupCharge, perQuantity: quantityCost, total: total, calculation: calculation, name: styleName };
  }

calculateDrillHoleCost(quantity) {
  const diameterValue = this.drillDiameterSelect?.value;
  const positionValue = this.drillPositionSelect?.value;
  
  // If no drill diameter selected or "None" selected, return zero cost
  if (!diameterValue || diameterValue === '' || diameterValue === '0') {
    return {
      setup: 0,
      perQuantity: 0,
      total: 0,
      calculation: '',
      name: ''
    };
  }
  
  // If diameter selected but no position, return zero cost
  if (!positionValue || positionValue === '') {
    return {
      setup: 0,
      perQuantity: 0,
      total: 0,
      calculation: '',
      name: ''
    };
  }

  
  // Apply drilling charges for ALL shapes

  const diameterOption = this.drillDiameterSelect.selectedOptions[0];
  const positionOption = this.drillPositionSelect.selectedOptions[0];
  
  // Get position costs (this is where ALL the pricing comes from)
  const positionSetupChargePence = parseInt(positionOption.dataset.setupCharge) || 0;
  const positionPricePerThousandPence = parseInt(positionOption.dataset.pricePerThousand) || 0;
  
  const positionSetupCharge = positionSetupChargePence / 100; // Convert to pounds
  const positionPricePerThousand = positionPricePerThousandPence / 100; // Convert to pounds
  
  // Calculate position quantity cost (per tag)
  const positionQuantityCost = (quantity / 1000) * positionPricePerThousand;
  
  // Total setup = position setup only (no diameter cost)
  const totalSetup = positionSetupCharge;
  
  // Total cost = setup costs + position quantity cost
  const total = totalSetup + positionQuantityCost;
  
  // Build description strings
  const diameterName = diameterOption.textContent || diameterValue + 'mm';
  const positionName = positionOption.textContent || positionValue;
  const calculation = `£${positionSetupCharge} setup + ${quantity} × £${positionPricePerThousand}/1000`;
  
  
  return {
    setup: totalSetup,
    perQuantity: positionQuantityCost,
    total: total,
    calculation: calculation,
    name: `${diameterName} → ${positionName}`
  };
}
  
  calculateEyeletCost(quantity) {
    if (!this.eyeletSelect || !this.eyeletSelect.value) {
      return { setup: 0, perQuantity: 0, total: 0, calculation: '', name: '' };
    }

    var eyeletOption = this.eyeletSelect.selectedOptions[0];

    // Data attributes are now in PENCE (from metaobject Money type)
    var pricePerThousandPence = parseInt(eyeletOption.dataset.pricePerThousand) || 0;
    var setupChargePence = parseInt(eyeletOption.dataset.setupCharge) || 0;

    // Convert pence to pounds for calculation
    var pricePerThousandPounds = pricePerThousandPence / 100;
    var setupChargePounds = setupChargePence / 100;

    var quantityCost = (quantity / 1000) * pricePerThousandPounds;
    var total = setupChargePounds + quantityCost;

    var eyeletName = eyeletOption.textContent.trim() || 'Eyelet';
    var calculation = '£' + setupChargePounds.toFixed(2) + ' setup + ' + quantity + ' × £' + pricePerThousandPounds.toFixed(2) + '/1000';

    return { setup: setupChargePounds, perQuantity: quantityCost, total: total, calculation: calculation, name: eyeletName };
  }
  
  //  STRING ATTACHMENT CALCULATION FIX
  calculateStringCost(quantity) {
    var attachmentValue = this.stringAttachmentSelect ? this.stringAttachmentSelect.value : null;
    var typeValue = this.stringTypeSelect ? this.stringTypeSelect.value : null;
    
    
    var isNoneType = !attachmentValue || 
                       attachmentValue === '' || 
                       attachmentValue === 'string_attachment_none' ||
                       attachmentValue.toLowerCase().includes('none') ||
                       attachmentValue === 'none';
    
    if (isNoneType) {

      return { setup: 0, perQuantity: 0, total: 0, calculation: '', name: '' };
    }
    
    var attachmentOption = this.stringAttachmentSelect ? this.stringAttachmentSelect.selectedOptions[0] : null;
    var typeOption = this.stringTypeSelect ? this.stringTypeSelect.selectedOptions[0] : null;
    
    if (!attachmentOption) {

      return { setup: 0, perQuantity: 0, total: 0, calculation: '', name: '' };
    }
    
    //  Enhanced attachment cost parsing
    var attachmentCostRaw = attachmentOption.dataset.attachmentCost;
    var attachmentCostPence = parseInt(attachmentCostRaw) || 0;
    
    
    //  Simplified logic - data should already be in pence
    // For strings_attached: attachment_cost = 100 GBP = 10000 pence
    var attachmentCostPerThousand = attachmentCostPence / 100; // Convert pence to pounds per 1000
    var attachmentCost = (quantity / 1000) * attachmentCostPerThousand;
    
    
    //  Enhanced string type cost calculation
    var stringTypeCost = 0;
    var stringName = attachmentOption.textContent || 'String';
    var calculation = '';
    
    if (typeOption && typeValue) {
      var pricePerStringRaw = typeOption.dataset.pricePerString;
      var pricePerString = parseFloat(pricePerStringRaw) || 0;
      stringTypeCost = quantity * pricePerString;
      stringName = typeOption.textContent || 'String';
      
      
      //  Clear calculation breakdown
      if (attachmentCost > 0 && stringTypeCost > 0) {
        calculation = quantity + ' strings × £' + pricePerString + ' + £' + attachmentCostPerThousand + '/1000 attachment';
      } else if (stringTypeCost > 0) {
        calculation = quantity + ' strings × £' + pricePerString;
      } else {
        calculation = quantity + ' strings × £' + attachmentCostPerThousand + '/1000 attachment';
      }
    } else if (attachmentCost > 0) {
      //  Clear attachment-only calculation
      calculation = quantity + ' strings @ £' + attachmentCostPerThousand + '/1000 = £' + attachmentCost.toFixed(2);

    }
    
    var totalCost = attachmentCost + stringTypeCost;
    
    
    return { 
      setup: 0, 
      perQuantity: totalCost, 
      total: totalCost, 
      calculation: calculation, 
      name: stringName 
    };
  }

  //  ✅ SERVICE CHARGE CALCULATION
calculateServiceCharge() {
  var shapeValue = this.shapeSelect.value;
  var isCustomShape = shapeValue === 'custom';
  var isCustomSizeOption = this.sizeSelect.value === 'custom_size';
  var hasCustomSize = isCustomShape || isCustomSizeOption;
  
  if (hasCustomSize) {
    var serviceChargePence = this.pricingConstants.service_charge || 1000; // £10 default
    var serviceCharge = serviceChargePence / 100; // Convert to pounds
    
    
    return {
      total: serviceCharge,
      calculation: 'Custom size/shape service charge',
      name: 'Custom Service Charge'
    };
  }
  
  return { total: 0, calculation: '', name: '' };
}
  
  getCurrentQuantity() {
    var quantityValue = this.quantitySelect.value;
    
    if (quantityValue === 'custom') {
      return parseInt(this.customQuantityInput.value) || 0;
    } else if (quantityValue) {
      return parseInt(quantityValue) || 0;
    }
    
    return 0;
  }
  
  //  Populate sizes for shape and add custom size option
  populateSizes(shapeHandle) {

    
    this.sizeSelect.innerHTML = '<option value="" hidden>Choose Size...</option>';
    
    var shapeSizes = this.sizesData[shapeHandle] || [];
    var materialOption = this.materialSelect.selectedOptions[0];
    var customSizeEnabled = !materialOption || materialOption.dataset.customSizeEnabled !== 'false';
    
    // Add standard sizes
    var self = this;
    shapeSizes.forEach(function(size) {
      var option = document.createElement('option');
      option.value = size.handle;
      option.textContent = size.display_name;
      option.dataset.width = size.width;
      option.dataset.height = size.height;
      option.dataset.tagsPerSheet = size.tags_per_sheet;
      option.dataset.flatWidth = size.flat_width;
      option.dataset.flatHeight = size.flat_height;
      
      self.sizeSelect.appendChild(option);
    });
    
    // Add custom size option for all shapes (except custom shape which already shows custom fields)
    if (shapeHandle !== 'custom' && customSizeEnabled) {
      var customOption = document.createElement('option');
      customOption.value = 'custom_size';
      customOption.textContent = 'Custom Size';
      customOption.dataset.customSize = 'true';
      
      this.sizeSelect.appendChild(customOption);

    }
    
    if (shapeSizes.length === 0 && shapeHandle !== 'custom') {

    } else {

    }
  }
  
  //  Show custom size fields with reason tracking
  showCustomSizeFields(reason) {
    this.isCustomSizeActive = true;
    this.customSizeReason = reason || 'unknown';
    
    // CRITICAL: Only hide size dropdown for custom SHAPE, not custom SIZE option
    if (reason === 'custom_shape') {
      // Custom shape: hide the entire size dropdown since shape itself is custom
      if (this.sizeFieldContainer) {
        this.sizeFieldContainer.style.display = 'none';
      }

    } else if (reason === 'custom_size_option') {
      // Custom size option: keep size dropdown visible so user can switch back
      if (this.sizeFieldContainer) {
        this.sizeFieldContainer.style.display = 'block';
      }

    }
    
    this.customSizeFields.style.display = 'block';
    
    // Update constraints for current material
    this.updateCustomSizeConstraints();
    

  }
  
  //  Hide custom size fields with reason tracking
  hideCustomSizeFields() {
    var previousReason = this.customSizeReason;
    
    this.isCustomSizeActive = false;
    this.customSizeReason = '';
    
    // Always restore size dropdown visibility when hiding custom fields
    if (this.sizeFieldContainer) {
      this.sizeFieldContainer.style.display = 'block';
    }
    
    this.customSizeFields.style.display = 'none';
    this.customWidthInput.value = '';
    this.customHeightInput.value = '';
    
    // Hide validation message
    if (this.sizeValidation) {
      this.sizeValidation.style.display = 'none';
    }
    

  }
  
  showCustomQuantityField() {
    this.customQuantityField.style.display = 'block';
  }
  
  hideCustomQuantityField() {
    this.customQuantityField.style.display = 'none';
    this.customQuantityInput.value = '';
  }
  
  hideCornerStyleField() {
    if (this.cornerStyleFieldContainer) {
      this.cornerStyleFieldContainer.style.display = 'none';
    }
    this.resetCornerStyles();
  }
  
  hideDrillHoleFields() {
    if (this.drillDiameterFieldContainer) {
      this.drillDiameterFieldContainer.style.display = 'none';
    }
    if (this.drillPositionFieldContainer) {
      this.drillPositionFieldContainer.style.display = 'none';
    }
    this.resetDrillHoles();
  }
  
  hideDrillPositionField() {
    if (this.drillPositionFieldContainer) {
      this.drillPositionFieldContainer.style.display = 'none';
    }
  }
  
  // ========================================
  // UPDATED: RESET METHODS WITH STATE UPDATES + NEW FEATURES
  // ========================================
  
  resetPrintOptions() {
    this.printSidesSelect.value = '';
    this.printSidesSelect.disabled = true;
    this.printSidesSelect.innerHTML = '<option value="" hidden>Choose Print Sides...</option>';
    this.updateSelectionState(this.printSidesSelect);
    
    this.printInkSelect.value = '';
    this.printInkSelect.disabled = true;
    this.printInkSelect.innerHTML = '<option value="" hidden>Choose Print Ink...</option>';
    this.updateSelectionState(this.printInkSelect);
  }
  
  resetCornerStyles() {
    if (!this.cornerStyleSelect) return;
    this.cornerStyleSelect.value = '';
    this.cornerStyleSelect.disabled = true;
    this.cornerStyleSelect.innerHTML = '<option value="">Select Corner Style</option>';
    this.updateSelectionState(this.cornerStyleSelect);
  }
  
  resetDrillHoles() {
    this.resetDrillDiameter();
    this.resetDrillPosition();
  }
  
  resetDrillDiameter() {
    if (!this.drillDiameterSelect) return;
    this.drillDiameterSelect.value = '';
    this.drillDiameterSelect.disabled = true;
    this.drillDiameterSelect.innerHTML = '<option value="">Select Drill Diameter</option>';
    this.updateSelectionState(this.drillDiameterSelect);
  }
  
  resetDrillPosition() {
    if (!this.drillPositionSelect) return;
    this.drillPositionSelect.value = '';
    this.drillPositionSelect.disabled = true;
    this.drillPositionSelect.innerHTML = '<option value="">Select Drill Position</option>';
    this.updateSelectionState(this.drillPositionSelect);
  }
  
  resetEyelets() {
    if (!this.eyeletSelect) return;
    this.eyeletSelect.value = '';
    this.eyeletSelect.disabled = true;
    this.updateSelectionState(this.eyeletSelect);
  }
  
  resetStrings(){
    if(!this.stringAttachmentSelect) return;
    
    this.stringAttachmentSelect.value = '';
    this.stringAttachmentSelect.disabled = true;
    this.stringTypeSelect.value = '';
    this.stringTypeSelect.disabled = true;
    this.stringTypeFieldContainer.style.display = 'none';
    this.updateSelectionState(this.stringAttachmentSelect);
    this.updateSelectionState(this.stringTypeSelect);
  }
  
  resetCalculator() {
    this.shapeSelect.disabled = true;
    this.sizeSelect.disabled = true;
    this.quantitySelect.disabled = true;
    this.resetSizeSelection();
    this.resetQuantitySelection();
    this.resetPrintOptions();
    this.resetCornerStyles();
    this.resetDrillHoles();
    this.resetEyelets();
    this.resetStrings();
    this.resetNewPricingFeatures(); // ✨ NEW: Reset new pricing features ✨
    this.hideCornerStyleField();
    this.hideDrillHoleFields();
    this.hideCustomSizeFields();
    this.hideCustomQuantityField();
    this.hidePriceDisplay();
    
    // Reset labels to original
    if (this.printSidesLabel) {
      this.printSidesLabel.textContent = this.originalLabels.printSides;
    }
    if (this.printInkLabel) {
      this.printInkLabel.textContent = this.originalLabels.printInk;
    }
    
    // Reset placeholders to default
    var printSidesPlaceholder = this.printSidesSelect.querySelector('option[hidden]');
    if (printSidesPlaceholder) {
      printSidesPlaceholder.textContent = 'Choose Print Sides...';
    }
    
    var printInkPlaceholder = this.printInkSelect.querySelector('option[hidden]');
    if (printInkPlaceholder) {
      printInkPlaceholder.textContent = 'Choose Print Ink...';
    }
    
    // Update all selection states
    this.updateAllSelectionStates();
    
    // 🚀 NEW: Notify external components about reset
    this.dispatchCalculatorEvent('ht-calculator-reset');
    this.dispatchCalculatorEvent('ht-calculator-ready', { isReady: false });
  }
  
  resetSizeSelection() {
    this.sizeSelect.innerHTML = '<option value="">Select Size</option>';
    this.sizeSelect.disabled = true;
    this.updateSelectionState(this.sizeSelect);
  }
  
  resetQuantitySelection() {
    this.quantitySelect.value = '';
    this.quantitySelect.disabled = true;
    this.hideCustomQuantityField();
    this.updateSelectionState(this.quantitySelect);
  }
  
  resetCustomFields() {
    this.hideCustomSizeFields();
    this.hideCustomQuantityField();
  }

  // Selection State Tracking Method 
  updateSelectionState(selectElement) {
    const hasValidSelection = selectElement.value && 
                             selectElement.value !== "" && 
                             selectElement.value !== "choose" &&
                             !selectElement.value.includes("Choose") &&
                             !selectElement.disabled;
    
    selectElement.toggleAttribute('data-has-selection', hasValidSelection);
    selectElement.classList.toggle('has-selection', hasValidSelection);
    
  }
  
  // Add this method after your existing updateSelectionState() method
updateAllSelectionStates() {
  const allSelects = [
    this.materialSelect,
    this.shapeSelect, 
    this.sizeSelect,
    this.quantitySelect,
    this.printSidesSelect,
    this.printInkSelect,
    this.cornerStyleSelect,
    this.drillDiameterSelect,
    this.drillPositionSelect,
    this.eyeletSelect,
    this.stringAttachmentSelect,
    this.stringTypeSelect
  ];
  
  allSelects.forEach(select => {
    if (select) {
      this.updateSelectionState(select);
    }
  });
}

  // Enable drill position selection
  enableDrillPositionSelection() {
    var shapeOption = this.shapeSelect.selectedOptions[0];
    
    if (!shapeOption || !this.drillPositionSelect || !this.drillPositionFieldContainer) {

      return;
    }
    
    var allowedDrillPositions = shapeOption.dataset.allowedDrillPositions;
    
    if (allowedDrillPositions && allowedDrillPositions.trim() !== '') {
      this.drillPositionFieldContainer.style.display = 'block';
      this.drillPositionSelect.disabled = false;
      this.populateDrillPositions(allowedDrillPositions);

    } else {
      this.hideDrillPositionField();

    }
  }
  
  // Helper: Check if current shape is round or oval
  isRoundOrOvalShape() {
    if (!this.shapeSelect) return false;
    var shapeValue = this.shapeSelect.value;
    return shapeValue === 'round' || shapeValue === 'oval';
  }

  // Helper: Check if an eyelet is selected
  isEyeletSelected() {
    if (!this.eyeletSelect) return false;
    var eyeletValue = this.eyeletSelect.value;
    return eyeletValue &&
           eyeletValue !== '' &&
           eyeletValue !== 'eyelet_none' &&
           !eyeletValue.toLowerCase().includes('none');
  }

  // Refresh drill diameters (called when eyelet selection changes)
  refreshDrillDiameters() {
    if (!this.shapeSelect || !this.drillDiameterSelect) return;

    var shapeOption = this.shapeSelect.selectedOptions[0];
    if (!shapeOption) return;

    var allowedDrillDiameters = shapeOption.dataset.allowedDrillDiameters;
    if (allowedDrillDiameters && allowedDrillDiameters.trim() !== '') {
      this.populateDrillDiameters(allowedDrillDiameters);
    }
  }

  //  Populate drill diameters with selection preservation
  populateDrillDiameters(allowedDiametersString) {
    if (!this.drillDiameterSelect) return;

    //  Preserve existing selection when repopulating
    var previousSelection = this.drillDiameterSelect.value;

    // Clear existing options
    this.drillDiameterSelect.innerHTML = '<option value="" hidden>Choose Drill Diameter...</option>';

    // Parse allowed diameters with improved handling
    var allowedDiameters = [];

    if (allowedDiametersString && allowedDiametersString.length > 0) {
      // First try splitting by comma
      var tempDiameters = allowedDiametersString.split(/[,•]/).map(function(d) { return d.trim(); }).filter(function(d) { return d; });

      // If no commas found but we have a string of digits, split each character
      if (tempDiameters.length === 1 && /^\d+$/.test(tempDiameters[0]) && tempDiameters[0].length > 1) {
        allowedDiameters = tempDiameters[0].split('').filter(function(d) { return d && d !== '0'; });
      } else {
        allowedDiameters = tempDiameters;
      }

      // Always ensure "0" (None) is available
      if (!allowedDiameters.includes('0')) {
        allowedDiameters.unshift('0');
      }
    }

    // For round/oval shapes: special drill hole logic based on eyelet selection
    var isRoundOrOval = this.isRoundOrOvalShape();
    var eyeletSelected = this.isEyeletSelected();

    // Any shape + eyelet: ONLY show 4mm (eyelets require a 4mm drill hole)
    // Round/oval + no eyelet: show None and 3mm only (hide 4mm)
    var eyeletForced4mm = eyeletSelected;
    var hide4mm = isRoundOrOval && !eyeletSelected;

    var self = this;
    var foundPreviousSelection = false;

    // Add "None" option first (but not if eyelet forces 4mm)
    if (this.drillDiametersData['0'] && !eyeletForced4mm) {
      var noneOption = document.createElement('option');
      noneOption.value = '0';
      noneOption.textContent = this.drillDiametersData['0'].display_name;
      noneOption.dataset.diameterValue = '0';
      noneOption.dataset.price = this.drillDiametersData['0'].price;
      noneOption.dataset.handle = this.drillDiametersData['0'].handle;
      this.drillDiameterSelect.appendChild(noneOption);

      if (noneOption.value === previousSelection) {
        foundPreviousSelection = true;
      }
    }

    // Add each allowed drill diameter
    allowedDiameters.forEach(function(diameterValue) {
      if (diameterValue === '0') return; // Skip "None" (handled above)

      // Round/oval + eyelet: ONLY allow 4mm
      if (eyeletForced4mm && diameterValue !== '4') {
        return;
      }

      // Round/oval + no eyelet: hide 4mm
      if (hide4mm && diameterValue === '4') {
        return;
      }

      var diameterData = self.drillDiametersData[diameterValue];

      if (diameterData) {
        var option = document.createElement('option');
        option.value = diameterValue;

        // Use display_name if available and valid, otherwise create a clean one
        var displayName = diameterData.display_name;
        if (!displayName || displayName.includes('mmm') || displayName.length > 10) {
          displayName = diameterValue + 'mm';
        }
        option.textContent = displayName;

        option.dataset.diameterValue = diameterValue;
        option.dataset.price = diameterData.price;
        option.dataset.handle = diameterData.handle;

        self.drillDiameterSelect.appendChild(option);

        //  Check if this was the previously selected option
        if (option.value === previousSelection) {
          foundPreviousSelection = true;
        }
      } else {
        // Create fallback option for missing diameter data
        var option = document.createElement('option');
        option.value = diameterValue;
        option.textContent = diameterValue + 'mm';
        option.dataset.diameterValue = diameterValue;
        option.dataset.price = '1500'; // Default price in pence
        option.dataset.handle = 'drill_hole_diameter_' + diameterValue + 'mm';

        self.drillDiameterSelect.appendChild(option);

        if (option.value === previousSelection) {
          foundPreviousSelection = true;
        }
      }
    });

    //  Restore previous selection if it's still valid
    if (foundPreviousSelection && previousSelection) {
      this.drillDiameterSelect.value = previousSelection;
    }

    // If eyelet forces 4mm for round/oval, auto-select 4mm
    if (eyeletForced4mm) {
      this.drillDiameterSelect.value = '4';
      // Trigger change to update position field
      this.onDrillDiameterChange();
    }
    // If previous selection was 4mm and we're now hiding it, reset to default
    else if (hide4mm && previousSelection === '4') {
      // Reset to 3mm if available, otherwise None
      var has3mm = false;
      for (var i = 0; i < this.drillDiameterSelect.options.length; i++) {
        if (this.drillDiameterSelect.options[i].value === '3') {
          has3mm = true;
          break;
        }
      }
      this.drillDiameterSelect.value = has3mm ? '3' : '0';
      // Trigger change to update position field
      this.onDrillDiameterChange();
    }

  }

// Populate drill positions based on allowed values (STATE-PRESERVING VERSION)
populateDrillPositions(allowedPositionsString) {
  if (!this.drillPositionSelect) return;
  
  // 🔧 PRESERVE current selection before clearing
  var currentSelection = this.drillPositionSelect.value;

  // Clear existing options
  this.drillPositionSelect.innerHTML = '<option value="" hidden>Choose Drill Position...</option>';
  
  // Parse allowed positions with improved handling
  var allowedPositions = [];
  
  if (allowedPositionsString && allowedPositionsString.length > 0) {
    // First try splitting by comma
    var tempPositions = allowedPositionsString.split(/[,•]/).map(function(p) { 
      return p.trim(); 
    }).filter(function(p) { return p; });
    
    // If we got one result that looks concatenated, try to split it intelligently
    if (tempPositions.length === 1 && tempPositions[0].length > 15) {
      // Look for common position patterns
      var concatenated = tempPositions[0];
      var knownPositions = ['top_centre', 'top_center', 'top_left', 'top_right', 'centre', 'center'];
      var extracted = [];
      
      knownPositions.forEach(function(position) {
        if (concatenated.includes(position)) {
          extracted.push(position);
          concatenated = concatenated.replace(position, '');
        }
      });
      
      allowedPositions = extracted.length > 0 ? extracted : tempPositions;
    } else {
      allowedPositions = tempPositions;
    }
  }
  
  
  var self = this;
  var selectionRestored = false;
  
  // Add each allowed drill position
  allowedPositions.forEach(function(positionCode) {
    var positionData = self.drillPositionsData[positionCode];
    
    if (positionData) {
      var option = document.createElement('option');
      option.value = positionCode;
      option.textContent = positionData.display_name;
      option.dataset.positionCode = positionCode;
      option.dataset.setupCharge = positionData.setup_charge;
      option.dataset.pricePerThousand = positionData.price_per_1000;
      option.dataset.foldedPricePerThousand = positionData.folded_price_per_1000;
      option.dataset.handle = positionData.handle;
      
      self.drillPositionSelect.appendChild(option);

      // 🔧 RESTORE SELECTION if this position was previously selected
      if (currentSelection === positionCode) {
        option.selected = true;
        selectionRestored = true;

      }
    }
  });
  
  // If previous selection couldn't be restored, clear the field
  if (!selectionRestored && currentSelection) {

    this.drillPositionSelect.value = '';
  }
  

}

  populateCornerStyles(allowedStylesString) {
    if (!this.cornerStyleSelect) return;
    
    //  Preserve existing selection when repopulating
    var previousSelection = this.cornerStyleSelect.value;
    
    // Load corner style data from metaobjects
    var cornerStylesData = this.loadCornerStylesData();
    
    // Clear existing options
    this.cornerStyleSelect.innerHTML = '<option value="" hidden>Choose Corner Style...</option>';
    
    // Parse allowed styles with improved handling
    var allowedStyles = [];
    
    if (allowedStylesString && allowedStylesString.length > 0) {
      // Try splitting by comma first
      var tempStyles = allowedStylesString.split(',').map(function(s) { return s.trim(); }).filter(function(s) { return s; });
      
      // If we got one result that looks concatenated, try to split it intelligently
      if (tempStyles.length === 1 && tempStyles[0].length > 20) {
        // Look for common patterns like "squareluggageradius_2mm" and split them
        var concatenated = tempStyles[0];
        var knownStyles = ['square', 'luggage', 'radius_2mm', 'radius_7mm', 'round'];
        var extracted = [];
        
        knownStyles.forEach(function(style) {
          if (concatenated.includes(style)) {
            extracted.push(style);
            concatenated = concatenated.replace(style, '');
          }
        });
        
        allowedStyles = extracted.length > 0 ? extracted : tempStyles;
      } else {
        allowedStyles = tempStyles;
      }
    }
    
    
    // Add each allowed corner style
    var self = this;
    var foundPreviousSelection = false;
    allowedStyles.forEach(function(styleCode) {
      var option = document.createElement('option');
      option.value = 'corner_style_' + styleCode;
      
      var styleData = cornerStylesData[styleCode] || 
                     cornerStylesData['corners_' + styleCode] ||
                     cornerStylesData['corner_' + styleCode];
      
      if (styleData) {
        option.textContent = styleData.display_name;
        option.dataset.pricePerThousand = styleData.price_per_1000;
        option.dataset.setupCharge = styleData.setup_charge;
        option.dataset.styleCode = styleCode;
      } else {
        // Fallback for unknown styles
        var displayNames = {
          'square': 'Square Corners',
          'luggage': 'Luggage Corners', 
          'radius_2mm': '2mm Radius',
          'radius_7mm': '7mm Radius'
        };
        
        option.textContent = displayNames[styleCode] || styleCode.replace('_', ' ').toUpperCase();
        option.dataset.pricePerThousand = '1000';
        option.dataset.setupCharge = '1000';
        option.dataset.styleCode = styleCode;
      }
      
      self.cornerStyleSelect.appendChild(option);
      
      //  Check if this was the previously selected option
      if (option.value === previousSelection) {
        foundPreviousSelection = true;
      }
    });
    
    //  Restore previous selection if it's still valid
    if (foundPreviousSelection && previousSelection) {
      this.cornerStyleSelect.value = previousSelection;

    }
    

  }

  hideCornerStyleField() {
  if (this.cornerStyleFieldContainer) {
    this.cornerStyleFieldContainer.style.display = 'none';
  }
  if (this.cornerStyleSelect) {
    this.cornerStyleSelect.disabled = true;
    this.cornerStyleSelect.value = '';
    this.updateSelectionState(this.cornerStyleSelect);
  }

}
  
  //  Check for valid custom size considering both scenarios
  hasValidCustomSize() {
    if (!this.isCustomSizeActive) {

      return false;
    }
    
    var width = parseFloat(this.customWidthInput.value) || 0;
    var height = parseFloat(this.customHeightInput.value) || 0;
    
    
    if (width <= 0 || height <= 0) {

      return false;
    }
    
    var isValidationPassed = this.validateCustomSize();
    
    return isValidationPassed;
  }
  
  hidePriceDisplay() {
    var priceSection = document.querySelector('.ht-calculator-price-section');
    if (priceSection) {
      priceSection.style.display = 'none';
    }
  }
  
  showPriceDisplay() {
    var priceSection = document.querySelector('.ht-calculator-price-section');
    if (priceSection) {
      priceSection.style.display = 'block';
    }
  }
  
  parsePrice(priceString) {
    if (!priceString) return 0;
    
    var cleanPrice = priceString.toString()
      .replace(/[£$€]/g, '')
      .replace(/GBP/g, '')
      .replace(/,/g, '')
      .trim();
    
    var parsed = parseFloat(cleanPrice);
    return isNaN(parsed) ? 0 : parsed;
  }
  
  formatPrice(price) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2
    }).format(price);
  }

  roundToPence(amount) {
  return Math.round((amount || 0) * 100) / 100;
}
}

// Initialize calculator when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('ht-calculator-form')) {
    window.htCalculator = new HTCalculator();
  }
});

window.HTCalculator = HTCalculator;